(function waitForVueAndPinia() {
    if (window.Vue && window.Pinia) {
        const { createPinia } = window.Pinia;
        window.VueAppGlobals = { pinia: createPinia() };
        window.dispatchEvent(new Event("vue-ready"));
        window.recaptcha = Pinia.defineStore('recaptcha', {
            actions: {
                async handleRecaptchaToken(token) {
                    const vehicleSearch = window.vehicleSearch();
                    vehicleSearch.getVehicle(token)
                },
            },
        });
        window.globalTools = Pinia.defineStore('globalTools', {
            actions: {
                async genericQuery(queryString) {
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query: queryString })
                    };
                    const response = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                    const object = await response.json()
                    if (object?.errors) {
                        return object.errors;
                    }
                    if (object) {
                        return object
                    } else {
                        return [{ message: "Unknown error" }];
                    }
                }
            }
        })
        window.customerTools = Pinia.defineStore('customerTools', {
            actions: {
                async getCustomer(dataTypeArray, user) {
                    let params = JSON.stringify(dataTypeArray).replaceAll('[', '').replaceAll(']', '').replaceAll('"', '');
                    let endpoint = `${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}user?type=${params}`
                    const options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-user-id': user
                        }
                    };
                    try {
                        const response = await fetch(endpoint, options);
                        const object = await response.json();
                        return object;
                    } catch (e) {
                        console.error(`Failure to retrieve user: ${e}`);
                    }
                },
                async customerSubmission(jsonData, user) {
                    let endpoint = `${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}user`
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-user-id': user
                        },
                        body: JSON.stringify(jsonData)
                    };
                    try {
                        const response = await fetch(endpoint, options);
                        if (!response.ok) {
                            throw new Error('Failed to submit user data')
                        }
                    } catch (e) {
                        console.error(`Failure to retrieve user: ${e}`);
                    }
                }
            }
        })
        const _pageLoadTime = Date.now();
        window.promo = Pinia.defineStore('promo', {
            state: () => ({
                currentTime: Date.now(),
                needScroll: Vue.ref(false)
            }),
            actions: {
                promoTimer(endDate, mode) {
                    if (!endDate) return null;
                    const diff = endDate - this.currentTime;
                    if (diff > 604800000) return null;
                    if (diff <= 0) {
                        return endDate > _pageLoadTime ? { ended: true } : null;
                    }
                    const prefix = mode === 'after-label' ? ' Ends in ' : 'Ends in ';
                    if (diff >= 86400000) {
                        const daysRemainder = Math.floor(diff / 86400000);
                        return { prefix, isDays: true, daysRemainder, hoursRemainder: Math.floor((diff % 86400000) / 3600000) };
                    }
                    return {
                        prefix,
                        isDays: false,
                        h: String(Math.floor(diff / 3600000)).padStart(2, '0'),
                        m: String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0'),
                        s: String(Math.floor((diff % 60000) / 1000)).padStart(2, '0'),
                    };
                },
                priceFormat(number) {
                    let dollar = new Intl.NumberFormat('en-AU', {
                        style: 'currency',
                        currency: 'AUD',
                    })
                    let price = dollar.format(number);
                    price = price.replace(/\.00$/, '').replace(/\.0$/, '');
                    return price;
                },
                calculatePromoValues(productNode) {
                    if (productNode.is_split) {
                        let index = productNode.collections.edges.findIndex(edge => edge?.node?.type?.value)
                        let splitIndex = productNode.splitProduct.node.collections.edges.findIndex(edge => edge?.node?.type?.value)
                        if (splitIndex > -1 && index > -1) {
                            let title = productNode.splitProduct.node.collections.edges[index]?.node?.title?.value
                            let colour = productNode.collections.edges[index]?.node?.colour?.value
                                || productNode.splitProduct.node.collections.edges[splitIndex]?.node?.colour?.value
                                || ''
                            const promoEndRaw = productNode.collections.edges[index]?.node?.end_date?.value
                                || productNode.splitProduct.node.collections.edges[splitIndex]?.node?.end_date?.value
                            productNode.promoEndDate = promoEndRaw ? new Date(promoEndRaw).getTime() : null
                            if (productNode.splitProduct.node.collections.edges[splitIndex]?.node?.type?.value === 'Cash Back' && productNode.collections.edges[index]?.node?.type?.value === 'Cash Back') {
                                let setPrice = ((Number(productNode.splitProduct.node.priceRange.minVariantPrice.amount) * 2) + (Number(productNode.priceRange.minVariantPrice.amount) * 2)) - Number(productNode.splitProduct.node.collections.edges[index]?.node?.value?.value)
                                let saving = productNode.splitProduct.node.collections.edges[index]?.node?.value?.value
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index]?.node?.type?.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.splitProduct.node.collections.edges[splitIndex]?.node?.type?.value === 'Percentage' && productNode.collections.edges[index]?.node?.type?.value === 'Percentage') {
                                let saving = ((Number(productNode.splitProduct.node.priceRange.minVariantPrice.amount) * 2) + (Number(productNode.priceRange.minVariantPrice.amount) * 2)) * Number(productNode.collections.edges[index]?.node?.value?.value / 100)
                                let setPrice = ((Number(productNode.splitProduct.node.priceRange.minVariantPrice.amount) * 2) + (Number(productNode.priceRange.minVariantPrice.amount) * 2)) - saving
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index]?.node?.type?.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.splitProduct.node.collections.edges[splitIndex]?.node?.type?.value === 'Buy 3 Get 4' && productNode.collections.edges[index]?.node?.type?.value === 'Buy 3 Get 4') {
                                let lower = productNode.priceRange.minVariantPrice.amount
                                let higher = productNode.splitProduct.node.priceRange.minVariantPrice.amount
                                if (productNode.splitProduct.node.priceRange.minVariantPrice.amount < lower) {
                                    lower = productNode.splitProduct.node.priceRange.minVariantPrice.amount
                                    higher = productNode.priceRange.minVariantPrice.amount
                                }
                                let setPrice = (Number(higher) * 2) + Number(lower) + 25
                                let saving = Number(lower) - 25
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.splitProduct.node.collections.edges[splitIndex].node.type.value == 'Other' && productNode.collections.edges[index].node.type.value == 'Other') {
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                            }
                        } else {
                            productNode.promo = false
                        }
                    } else {
                        let index = productNode.collections.edges.findIndex(edge => edge?.node?.type?.value)
                        if (index > -1) {
                            let title = productNode.collections.edges[index].node.title.value
                            let colour = productNode.collections.edges[index]?.node?.colour?.value || ''
                            const promoEndRaw = productNode.collections.edges[index]?.node?.end_date?.value
                            productNode.promoEndDate = promoEndRaw ? new Date(promoEndRaw).getTime() : null
                            if (productNode.collections.edges[index].node.type.value == 'Cash Back') {
                                let setPrice = (Number(productNode.priceRange.minVariantPrice.amount) * 4) - Number(productNode.collections.edges[index].node.value.value)
                                let saving = productNode.collections.edges[index].node.value.value
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.collections.edges[index].node.type.value == 'Percentage') {
                                let saving = (Number(productNode.priceRange.minVariantPrice.amount) * 4) * Number(productNode.collections.edges[index].node.value.value / 100)
                                let setPrice = (Number(productNode.priceRange.minVariantPrice.amount) * 4) - saving
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.collections.edges[index].node.type.value == 'Buy 3 Get 4') {
                                let setPrice = (Number(productNode.priceRange.minVariantPrice.amount) * 3) + 25
                                let saving = Number(productNode.priceRange.minVariantPrice.amount) - 25
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                                productNode.promoPriceForSet = this.priceFormat(setPrice)
                                productNode.promoUnitPrice = this.priceFormat(setPrice / 4)
                                productNode.saving = this.priceFormat(saving)
                            } else if (productNode.collections.edges[index].node.type.value == 'Other') {
                                productNode.promo = true
                                productNode.promoTitle = title
                                productNode.promoType = productNode.collections.edges[index].node.type.value
                                productNode.promoColour = colour
                            }
                        } else {
                            productNode.promo = false
                        }
                    }
                    return productNode;
                }
            },
        })
        window.fitmentStore = Pinia.defineStore('fitment', {
            state: () => ({
                selectedFitment: null
            }),
            actions: {
                setSelectedFitment(fitment) {
                    this.selectedFitment = fitment || null;
                    try {
                        window.dispatchEvent(new CustomEvent('fitment-updated', {
                            detail: this.selectedFitment
                        }));
                    } catch (e) { }
                }
            },
        });
        window.stock = Pinia.defineStore('stock', {
            state: () => ({
                PDPStock: Vue.ref(false),
                PLPStock: Vue.ref(false),
                stockLoading: false
            }),
            actions: {
                async requestStock(productIdArray, locationArray, qty, PLP) {
                    let productNumberArray = productIdArray.map((val) => {
                        return Number(val)
                    })
                    //Limit to 10 nearest locations
                    locationArray.splice(10);
                    let locationNumberArray = locationArray.map((val) => {
                        return Number(val)
                    })
                    let queryString = {
                        "mode": "D",
                        "quantity": qty,
                        "productGids": productNumberArray,
                        "locationGids": locationNumberArray
                    }
                    if (PLP) {
                        queryString = {
                            "mode": "L",
                            "quantity": qty,
                            "flipperSize": 5,
                            "productGids": productNumberArray,
                            "locationGids": locationNumberArray
                        }
                    }
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //"x-api-version": shopifyConfig.azureVersion
                        },
                        body: JSON.stringify(queryString)
                    };
                    const stockRequest = new Promise((resolve, reject) => {
                        const timeoutId = setTimeout(() => {
                            console.error('Stock query timeout');
                            reject(new Error('Stock query timeout'));
                        }, 10000)
                        fetch(`${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}stock`, options)
                            .then(async response => {
                                const text = await response.text();
                                clearTimeout(timeoutId);
                                if (!response.ok) {
                                    console.error('Backend error:', text);
                                    throw new Error(`HTTP ${response.status}`);
                                }

                                try {
                                    return JSON.parse(text);
                                } catch (e) {
                                    console.error('Response was not JSON:', text);
                                    throw e;
                                }
                            })
                            .then(data => resolve(data))
                            .catch(err => {
                                console.error('Error retrieving stock:', err);
                                reject(err);
                            });
                    });

                    const stockResponse = await stockRequest;
                    return stockResponse;
                },
                async PLPStockRequest(qty, customProductEdges) {
                    this.stockLoading = true;
                    const collection = window.collectionStore();
                    const storeSelector = window.storeSelector();
                    const productEdges = customProductEdges || (Array.isArray(collection.products?.edges) ? collection.products.edges : (Array.isArray(collection.products) ? collection.products : []));
                    const productList = productEdges;
                    let nearbyLocations = []
                    if (localStorage.getItem('storesUnder100')) {
                        try {
                            let parsedStores = JSON.parse(localStorage.getItem('storesUnder100'));
                            nearbyLocations = nearbyLocations.concat(parsedStores);
                        } catch (err) {
                            console.error(`Error retrieving nearby stores: ${err}`)
                        }
                    }
                    let requestLocations = nearbyLocations.map(location => location.node.id.replaceAll("gid://shopify/Location/", ""));
                    requestLocations.unshift(storeSelector.nearestStore.node.id.replaceAll("gid://shopify/Location/", ""))

                    let requestProducts = [];
                    let now = Date.parse(new Date());

                    // Build request list for main products and split products
                    for (let i = 0; i < productList.length; i++) {
                        const mainProduct = productList[i]?.node || productList[i];
                        if (!mainProduct?.id) continue;
                        const mainId = mainProduct.id.replaceAll("gid://shopify/Product/", "");

                        // Check main product
                        if (mainProduct?.stock) {
                            if (!mainProduct?.stockExpiry || mainProduct?.stockExpiry <= now || mainProduct?.stock?.available == null) {
                                requestProducts.push(mainId);
                            }
                        } else {
                            requestProducts.push(mainId);
                        }

                        // Check split product if it exists
                        const splitProduct = mainProduct?.splitProduct?.node || mainProduct?.splitProduct;
                        if (splitProduct?.id) {
                            if (splitProduct?.stock) {
                                if (!splitProduct?.stockExpiry || splitProduct?.stockExpiry <= now || splitProduct?.stock?.available == null) {
                                    const splitId = splitProduct.id.replaceAll("gid://shopify/Product/", "");
                                    requestProducts.push(splitId);

                                }
                            } else {
                                const splitId = splitProduct.id.replaceAll("gid://shopify/Product/", "");
                                requestProducts.push(splitId);

                            }
                        }
                    }
                    requestProducts = Array.from(new Set(requestProducts.filter(Boolean)));

                    let requestProductsArray = [];
                    let chunkSize = 4;


                    if (!requestProducts.length) {
                        this.stockLoading = false;
                        return;
                    }

                    for (let i = 0; i < requestProducts.length; i += chunkSize) {
                        const chunk = requestProducts.slice(i, i + chunkSize);
                        requestProductsArray.push(chunk);
                    }
                    let promises = [];
                    for (let i = 0; i < requestProductsArray.length; i++) {
                        promises.push(this.requestStock(requestProductsArray[i], requestLocations, qty, true)
                            .then((object) => {
                                for (let v = 0; v < object.length; v++) {
                                    let flipStock = []
                                    if (object[v]?.locations[0]?.breakdown) {
                                        flipStock = object[v]?.locations[0]?.breakdown?.map((id, index) => {
                                            if (id === null) {
                                                let idx = object[v]?.locations?.findIndex(loc => loc?.breakdown[index] != null);
                                                if (idx > -1) {
                                                    return {
                                                        selectedAvailable: false,
                                                        nearestStore: object[v].locations[idx].locationGid
                                                    }
                                                } else {
                                                    return {
                                                        selectedAvailable: false,
                                                        nearestStore: false
                                                    }
                                                }
                                            } else {
                                                return {
                                                    selectedAvailable: true,
                                                    nearestStore: object[v].locations[0].locationGid
                                                }
                                            }
                                        }) || {
                                            selectedAvailable: false,
                                            nearestStore: false
                                        }
                                    }
                                    const targetGid = `gid://shopify/Product/${object[v].productGid}`;
                                    const stockData = {
                                        "available": object?.[v]?.locations?.[0]?.available || null,
                                        "productGid": object?.[v]?.productGid || null,
                                        "variantGid": object?.[v]?.variantGid || null,
                                        "genericStorage": object?.[v]?.locations?.[0]?.genericStorage ? true : false,
                                        //"qtyInStore": (object?.[v]?.locations?.[0]?.breakdown?.findIndex(id => !id?.toLowerCase().includes('warehouse')) + 1),
                                        "qtyInStore": object?.[v]?.locations?.[0]?.breakdown?.filter(id => id !== null && !id?.toLowerCase().includes('warehouse')).length,
                                        "flip": flipStock || [],
                                        "leadDays": object?.[v]?.locations?.[0]?.availableDays || null,
                                        "leadDate": object?.[v]?.locations?.[0]?.availableDate || null
                                    }

                                    const stockExpiry = Date.parse(new Date()) + (shopifyConfig.stockCachingDuration * 60 * 1000);

                                    let matchProducts = productEdges.filter(edge => edge?.node?.id == targetGid)

                                    if (matchProducts.length > 0) {
                                        for (let t = 0; t < matchProducts.length; t++) {
                                            const matchNode = matchProducts[t]?.node;
                                            if (!matchNode) continue;
                                            if (matchNode.is_split && matchNode.splitProduct) {
                                                let idx = productEdges.findIndex(edge =>
                                                    edge?.node?.id == matchNode?.id &&
                                                    edge?.node?.splitProduct?.node?.id == matchNode?.splitProduct?.node?.id
                                                )
                                                if (idx > -1) {
                                                    productEdges[idx].node.stock = stockData;
                                                    productEdges[idx].node.stock.qty = qty;
                                                    productEdges[idx].node.stockExpiry = stockExpiry;
                                                    collection.stockCache.push(productEdges[idx]);
                                                }
                                            } else {
                                                const promo = window.promo()
                                                let idx = productEdges.findIndex(edge => edge?.node?.id == matchNode?.id)
                                                if (idx > -1) {
                                                    const promoEdges = productEdges[idx]?.node?.collections?.edges || []
                                                    let promoidx = promoEdges.findIndex(edge => edge?.node?.type?.value)
                                                    if (promoidx > -1) {
                                                        let promoSubtraction = 0
                                                        if (productEdges[idx]?.node?.collections?.edges[promoidx]?.node?.type?.value == 'Cash Back') {
                                                            promoSubtraction = Number(productEdges[idx].node.collections.edges[promoidx].node.value.value) || 0;
                                                        } else if (productEdges[idx]?.node?.collections?.edges[promoidx]?.node?.type?.value == 'Percentage') {
                                                            promoSubtraction = (Number(productEdges[idx].node.collections.edges[promoidx].node.value.value) / 100) * (Number(productEdges[idx].node.priceRange.minVariantPrice.amount) * 4) ||
                                                                (Number(productEdges[idx].node.collections.edges[promoidx].node.value) / 100) * (Number(productEdges[idx].node.priceRange.maxVariantPrice.amount) * 4) ||
                                                                (Number(productEdges[idx].node.collections.edges[promoidx].node.value) / 100) * (Number(productEdges[idx].node.price.replaceAll('$', '')) * 4) || 0;
                                                        } else if (productEdges[idx]?.node?.collections?.edges[promoidx]?.node?.type?.value == 'Buy 3 Get 4') {
                                                            promoSubtraction = Number(productEdges[idx].node.priceRange.minVariantPrice.amount) - 25 ||
                                                                Number(productEdges[idx].node.priceRange.maxVariantPrice.amount) - 25 ||
                                                                Number(productEdges[idx].node.price.replaceAll('$', '')) - 25 || 0;
                                                        }
                                                        for (let z = 0; z < stockData.flip.length; z++) {
                                                            if (z < 3) {
                                                                stockData.flip[z].pricePerUnit = promo.priceFormat(Number(productEdges[idx].node.priceRange.minVariantPrice.amount)) ||
                                                                    promo.priceFormat(Number(productEdges[idx].node.priceRange.maxVariantPrice.amount)) ||
                                                                    promo.priceFormat(Number(productEdges[idx].node.price.replaceAll('$', '')))
                                                                stockData.flip[z].saving = false;
                                                            } else {
                                                                stockData.flip[z].pricePerUnit = promo.priceFormat((((z + 1) * Number(productEdges[idx].node.priceRange.minVariantPrice.amount)) - promoSubtraction) / (z + 1)) ||
                                                                    promo.priceFormat((((z + 1) * Number(productEdges[idx].node.priceRange.maxVariantPrice.amount)) - promoSubtraction) / (z + 1)) ||
                                                                    promo.priceFormat((((z + 1) * Number(productEdges[idx].node.price.replaceAll('$', ''))) - promoSubtraction) / (z + 1))
                                                                stockData.flip[z].saving = promo.priceFormat(promoSubtraction);
                                                            }

                                                        }
                                                    } else {
                                                        for (let z = 0; z < stockData.flip.length; z++) {
                                                            stockData.flip[z].pricePerUnit = promo.priceFormat(Number(productEdges[idx].node.priceRange.minVariantPrice.amount)) ||
                                                                promo.priceFormat(Number(productEdges[idx].node.priceRange.maxVariantPrice.amount)) ||
                                                                promo.priceFormat(Number(productEdges[idx].node.price.replaceAll('$', '')))
                                                            stockData.flip[z].saving = false;
                                                        }
                                                    }
                                                    productEdges[idx].node.stock = stockData;
                                                    productEdges[idx].node.stockExpiry = stockExpiry;
                                                    productEdges[idx].node.stock.qty = qty;
                                                    collection.stockCache.push(productEdges[idx]);
                                                }
                                            }
                                        }
                                    }

                                    let splitProducts = productEdges.filter(edge => edge?.node?.splitProduct?.node?.id == targetGid)
                                    if (splitProducts.length > 0) {
                                        for (let t = 0; t < splitProducts.length; t++) {
                                            const splitNode = splitProducts[t]?.node;
                                            if (!splitNode) continue;
                                            let idx = productEdges.findIndex(edge =>
                                                edge?.node?.id == splitNode?.id &&
                                                edge?.node?.splitProduct?.node?.id == splitNode?.splitProduct?.node?.id
                                            )
                                            if (idx > -1) {
                                                const splitTarget = productEdges[idx]?.node?.splitProduct?.node;
                                                if (!splitTarget) continue;
                                                productEdges[idx].node.splitProduct.node.stock = stockData;
                                                productEdges[idx].node.splitProduct.node.stockExpiry = stockExpiry;
                                                productEdges[idx].node.splitProduct.node.stock.qty = qty;
                                                collection.stockCache.push(productEdges[idx].node.splitProduct);
                                            }
                                        }
                                    }

                                    if (matchProducts.length === 0 && splitProducts.length === 0) {
                                        console.warn('PLPStockRequest: product not found (neither main nor split)', {
                                            targetGid,
                                            productGid: object[v].productGid
                                        });
                                    }
                                }

                            })
                            .catch(error => {
                                console.error('PLPStockRequest error:', error);
                                const stockExpiry = Date.parse(new Date()) + (shopifyConfig.stockCachingDuration * 60 * 1000);
                                for (const failedId of requestProductsArray[i]) {
                                    const targetGid = `gid://shopify/Product/${failedId}`;
                                    const idx = productEdges.findIndex(edge => edge?.node?.id === targetGid);
                                    if (idx > -1) {
                                        productEdges[idx].node.stock = { available: 'ERROR' };
                                        productEdges[idx].node.stockExpiry = stockExpiry;
                                    }
                                    const splitIdx = productEdges.findIndex(edge => edge?.node?.splitProduct?.node?.id === targetGid);
                                    if (splitIdx > -1) {
                                        productEdges[splitIdx].node.splitProduct.node.stock = { available: 'ERROR' };
                                        productEdges[splitIdx].node.splitProduct.node.stockExpiry = stockExpiry;
                                    }
                                }
                            })
                        )
                    }
                    await Promise.all(promises);
                    localStorage.setItem('stockCache', JSON.stringify(collection.stockCache));
                    this.stockLoading = false;
                    return true;
                }
            }
        });

        window.pdpNewProduct = Pinia.defineStore('pdpNewProduct', {
            state: () => {
                const raw = window.pdpRaw || {};
                return {
                    promo: raw.promo || { type: '', value: 0, colour: '', title: '', endDate: '' },
                    spec: raw.spec || {},
                    headline: raw.headline || '',
                    summary: raw.summary || '',
                    performance: raw.performance || null,
                    benefits: raw.benefits || null,
                    imageCount: raw.imageCount || 0,
                };
            },
            getters: {
                promoColour: (state) => state.promo.colour || '',
                promoTitle: (state) => state.promo.title || '',
                // Raw type/value/endDate — GGproduct.js's shared promo/discount logic and
                // the compare-strip "current item" perf overlay read these directly.
                promoType: (state) => state.promo.type || '',
                promoValue: (state) => state.promo.value ?? 0,
                promoEndDate: (state) => state.promo.endDate || '',

                isWheelProduct: () => String(window.prodType || '').toLowerCase().includes('wheel'),
                wheelTitleParts: () => String(window.prodTitle || '').split('|').map((part) => part.trim()),
                isWheelTitleSplit() {
                    return this.isWheelProduct && String(window.prodTitle || '').includes('|');
                },

                productDescriptionHtml: () => String(window.prodDetails || ''),
                hasDescription() {
                    const text = this.productDescriptionHtml.replace(/\r?\n/g, '').trim();
                    return text !== '' && text !== '<p></p>';
                },

                specWidth: (state) => state.spec.width ?? '',
                specAspectRatio: (state) => state.spec.aspectRatio ?? '',
                specRimDiameter: (state) => state.spec.rimDiameter ?? '',
                specLoadIndex: (state) => state.spec.loadIndex ?? '',
                specSpeedRating: (state) => state.spec.speedRating ?? '',
                specBolt: (state) => state.spec.bolt ?? '',
                specPcd: (state) => state.spec.pcd ?? '',
                specLoadRating: (state) => state.spec.loadRating ?? '',
                specCentreBore: (state) => state.spec.centreBore ?? '',
                specOffset: (state) => state.spec.offset ?? '',

                hasSpecs() {
                    return this.isWheelProduct
                        ? !this.isBlank(this.specRimDiameter) || !this.isBlank(this.specWidth) || !this.isBlank(this.specBolt) || !this.isBlank(this.specPcd) || !this.isBlank(this.specLoadRating) || !this.isBlank(this.specCentreBore) || !this.isBlank(this.specOffset)
                        : !this.isBlank(this.specWidth) || !this.isBlank(this.specAspectRatio) || !this.isBlank(this.specRimDiameter) || !this.isBlank(this.specLoadIndex) || !this.isBlank(this.specSpeedRating);
                },
                specReading() {
                    if (this.isWheelProduct || this.isBlank(this.specWidth) || this.isBlank(this.specAspectRatio) || this.isBlank(this.specRimDiameter)) return '';
                    const loadIndex = this.isBlank(this.specLoadIndex) ? '' : ` ${this.specLoadIndex}`;
                    const speedRating = this.isBlank(this.specSpeedRating) ? '' : this.specSpeedRating;
                    return `${this.specWidth}/${this.specAspectRatio}R${this.specRimDiameter}${loadIndex}${speedRating}`;
                },

                pdpHeadline: (state) => state.headline || '',
                pdpSummary: (state) => {
                    if (state.summary) return state.summary;
                    const stripHtml = (html) => String(html || '').replace(/<[^>]*>/g, '');
                    const truncate = (str, len) => (str.length > len ? `${str.slice(0, len - 1).trim()}…` : str);
                    return truncate(stripHtml(window.prodDetails || ''), 460);
                },

                bestForList: (state) => (Array.isArray(state.benefits?.best_for) ? state.benefits.best_for : []).filter((line) => line),
                considerList: (state) => (Array.isArray(state.benefits?.consider_another_if) ? state.benefits.consider_another_if : []).filter((line) => line),
                pdpFitment: (state) => state.benefits?.fitment || '',
                pdpIdealFor: (state) => state.benefits?.ideal_for || '',

                perfMetricFields: () => [
                    ['fuel_efficiency', 'FuelEfficiency', 'Fuel efficiency', 'Fuel Eff.'],
                    ['wet_grip', 'WetGrip', 'Wet grip', 'Wet Grip'],
                    ['comfort', 'Comfort', 'Comfort', 'Comfort'],
                    ['noise', 'Noise', 'Noise', 'Noise'],
                    ['dry_grip', 'DryGrip', 'Dry grip', 'Dry Grip'],
                    ['braking', 'Braking', 'Braking', 'Braking'],
                    ['handling', 'Handling', 'Handling', 'Handling'],
                    ['longevity', 'Longevity', 'Longevity', 'Longevity'],
                ],

                perfMetricFullOrder: () => ['DryGrip', 'WetGrip', 'Braking', 'Handling', 'Comfort', 'Noise', 'FuelEfficiency', 'Longevity'],

                // {value, pct, quickShow} per metric, keyed by suffix — one getter instead of
                // a separate perf<Suffix>/perf<Suffix>Pct/perf<Suffix>QuickShow getter per metric.
                perfMetricsByKey(state) {
                    const perf = state.performance?.performance || {};
                    const byKey = {};
                    this.perfMetricFields.forEach(([jsonKey, suffix]) => {
                        byKey[suffix] = {
                            value: perf[jsonKey]?.value || '',
                            pct: perf[jsonKey]?.pct || 0,
                            quickShow: !!perf[jsonKey]?.quick_show,
                        };
                    });
                    return byKey;
                },

                // Rows for the compact "Right for you?" ratings — label + value + percent bar.
                compactPerfMetrics() {
                    return this.perfMetricFields
                        .map(([, suffix, label]) => ({ key: suffix, label, ...this.perfMetricsByKey[suffix] }))
                        .filter((m) => m.value && m.quickShow);
                },
                // Same shape, "Full performance" order/inclusion (ignores quickShow).
                fullPerfMetrics() {
                    const labelBySuffix = {};
                    this.perfMetricFields.forEach(([, suffix, label]) => { labelBySuffix[suffix] = label; });
                    return this.perfMetricFullOrder
                        .map((suffix) => ({ key: suffix, label: labelBySuffix[suffix], ...this.perfMetricsByKey[suffix] }))
                        .filter((m) => m.value);
                },
                // Which compare-table columns to show, driven by the CURRENT product's own
                // metrics (compareTableRows' other rows pull item[`perf${col.key}`] per column).
                compareColumns() {
                    return this.perfMetricFields
                        .map(([, suffix, , shortLabel]) => ({ key: suffix, label: shortLabel, value: this.perfMetricsByKey[suffix].value }))
                        .filter((m) => m.value);
                },

                hasCompactRatings() { return this.compactPerfMetrics.length > 0; },
                hasFullRatings() { return this.fullPerfMetrics.length > 0; },

                hasBestFor() { return this.bestForList.length > 0; },
                hasConsider() { return this.considerList.length > 0; },
                hasLeftFitContent() { return this.hasBestFor || this.hasConsider; },
                hasFitIntro() { return !!(this.pdpFitment || this.pdpIdealFor); },
                hasFitBlock() { return this.hasLeftFitContent || this.hasCompactRatings || this.hasFitIntro; },
                hasTwoFitColumns() {
                    return this.hasCompactRatings ? this.hasLeftFitContent : (this.hasBestFor && this.hasConsider);
                },

                displayedImageCount: (state) => Math.min(Number(state.imageCount || 0), 4),
            },
            actions: {
                isBlank(v) {
                    return v === undefined || v === null || v === '';
                },
            },
        });
        window.search = Pinia.defineStore('search', {
            state: () => ({
                predictions: Vue.ref({
                    products: [],
                    queries: [],
                    pages: [],
                    collections: []
                }),
                queryString: Vue.ref(''),
                collectionMatch: Vue.ref(false),
            }),
            actions: {
                inputTest(string) {
                    const regexes = [
                        {
                            expression: /^\d{3}\s\d\d\s\d\d$/,
                            function: (string) => {
                                return string.replace(' ', '/').replace(' ', 'R');
                            }
                        },
                        {
                            expression: /^\d{3}\/\d\d\/\d\d$/,
                            function: (string) => {
                                return string.split('').reverse().join('').replace('/', 'R').split('').reverse().join('');
                            }
                        },
                        {
                            expression: /^\d{5}R\d\d$/i,
                            function: (string) => {
                                return `${string.substring(0, 3)}/${string.substring(3, string.length)}`;
                            }
                        },
                        {
                            expression: /^\d{7}$/,
                            function: (string) => {
                                return `${string.substring(0, 3)}/${string.substring(3, 5)}R${string.substring(5, string.length)}`;
                            }
                        }
                    ]
                    this.collectionMatch = false;
                    let output = string;
                    let bool = false;
                    for (let i = 0; i < regexes.length; i++) {
                        if (regexes[i]?.expression?.test(string)) {
                            output = regexes[i].function(string);
                            bool = true;
                            this.collectionMatch = true;
                            break;
                        }
                    }
                    return [output, bool];
                },
                async predictiveSearch(string) {
                    let runSearch = false;
                    if (string.length > 2) {
                        runSearch = true;
                    };
                    if (string.length < this.queryString.length) {
                        this.predictions = {
                            products: [],
                            queries: [],
                            pages: [],
                            collections: []
                        }
                    }
                    if (runSearch) {
                        let searchOutput = this.inputTest(string);
                        let searchString = searchOutput[0];
                        let queryString = `${shopifyConfig.storeURL}/search/suggest.json?q=${searchString}`
                        let type = 'query,product,page'
                        if (this.collectionMatch) {
                            type = 'query,product,collection,page'
                        }
                        let limit = 5;
                        let scope = 'each';
                        let unavailable = 'last';
                        let fields = 'title,product_type,variants.sku,vendor'
                        queryString = `${queryString}&resources[type]=${type}&resources[limit]=${limit}&resources[limit_scope]=${scope}&resources[options][unavailable_products]=${unavailable}&resources[options][fields]=${fields}`
                        fetch(queryString).then(response => response.json())
                            .then(object => {
                                const prodPredict = object.resources.results.products || []
                                const queryPredict = object.resources.results.queries || []
                                const pagePredict = object.resources.results.queries || []
                                const collectionPredict = object.resources.results.pages || []
                                this.predictions.products = prodPredict
                                this.predictions.queries = queryPredict
                                this.predictions.pages = pagePredict
                                this.predictions.collections = collectionPredict
                            })
                    }
                },
                submitSearch(string) {
                    let searchOutput = this.inputTest(string);
                    let searchString = encodeURI(searchOutput[0]);
                    if (searchOutput[1]) {
                        searchString = searchOutput[0];
                        let searchSizeFilters = [];
                        let width = searchString.split('/')[0];
                        searchSizeFilters.push(`{productMetafield:{namespace:"wheel_tyre_spec",key:"width",value:"${width}"}}`);
                        let aspectRatio = searchString.split('/')[1].split('R')[0];
                        searchSizeFilters.push(`{productMetafield:{namespace:"tyre_spec",key:"aspect_ratio",value:"${aspectRatio}"}}`);
                        let rimDiameter = searchString.split('R')[1];
                        searchSizeFilters.push(`{productMetafield:{namespace:"wheel_tyre_spec",key:"rim_diameter",value:"${rimDiameter}"}}`)
                        localStorage.setItem('searchSizeFilters', JSON.stringify(searchSizeFilters))
                    }
                    window.location.href = `${shopifyConfig.storeURL}/search?q=${searchString}`;
                }
            },
        });
        window.storeSelector = Pinia.defineStore('storeSelector', {
            state: () => ({
                location: Vue.ref(false),
                nearestStore: Vue.ref(false),
                storeList: Vue.ref(false),
                storesWithinDistance: Vue.ref(false)
            }),
            actions: {
                haversineFormula(lat1, lon1, lat2, lon2) {
                    const R = 6371; // Radius of the Earth in km
                    const dLat = (lat2 - lat1) * (Math.PI / 180);
                    const dLon = (lon2 - lon1) * (Math.PI / 180);
                    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    return R * c;
                },
                isLocationClosed(node, dateStr) {
                    if (!node || (!node.closedFrom && !node.closedTo)) return false;
                    const checkDate = dateStr || new Date().toISOString().slice(0, 10);
                    if (node.closedFrom && checkDate < node.closedFrom) return false;
                    if (node.closedTo && checkDate > node.closedTo) return false;
                    return true;
                },
                formatClosedToDate(dateStr) {
                    if (!dateStr) return '';
                    const dateOpts = { day: 'numeric', month: 'long', year: 'numeric' };
                    return new Date(`${dateStr}T00:00:00`).toLocaleDateString('en-AU', dateOpts);
                },
                updateLocation(data) {
                    this.location = data;
                },
                isStoreLandingPage() {
                    const path = String(window.location.pathname || '').toLowerCase();
                    return /^\/pages\/.+-t-marts\/?$/.test(path);
                },
                normalizeNearestStore(store) {
                    if (!store) return null;
                    if (store.node) return store;
                    return { node: store };
                },
                backfillStoreContext(store, force = false) {
                    const normalizedStore = this.normalizeNearestStore(store);
                    const node = normalizedStore?.node;
                    if (!node?.id) return;

                    let hasStoresUnder100 = false;
                    let existingCount = 0;
                    try {
                        const parsed = JSON.parse(localStorage.getItem('storesUnder100') || '[]');
                        existingCount = Array.isArray(parsed) ? parsed.length : 0;
                        hasStoresUnder100 = existingCount > 0;
                    } catch (e) {
                        hasStoresUnder100 = false;
                        existingCount = 0;
                    }

                    if (!hasStoresUnder100) {
                        this.storesWithinDistance = [normalizedStore];
                        localStorage.setItem('storesUnder100', JSON.stringify([normalizedStore]));
                        if (localStorage.getItem(btoa('user'))) {
                            const customerTools = window.customerTools();
                            const submission = {
                                storesUnder100: {
                                    siteData: [normalizedStore],
                                    updated: Date.parse(new Date())
                                }
                            }
                            customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                        }
                        let updates = localStorage.getItem('updates');
                        if (updates) {
                            try {
                                let parsed = JSON.parse(updates);
                                parsed['storesUnder100'] = Date.parse(new Date());
                                localStorage.setItem('updates', JSON.stringify(parsed));
                            } catch (error) {
                                localStorage.removeItem('updates');
                                console.error(`Error retrieving update times: ${error}`)
                            }
                        }
                    }

                    if (!this.location && !localStorage.getItem('currentUserLocation')) {
                        if (node?.address?.latitude && node?.address?.longitude) {
                            const location = {
                                name: node.name || '',
                                latitude: node.address.latitude,
                                longitude: node.address.longitude
                            };
                            this.location = location;
                            localStorage.setItem('currentUserLocation', JSON.stringify(location));
                            if (localStorage.getItem(btoa('user'))) {
                                const customerTools = window.customerTools();
                                const submission = {
                                    currentUserLocation: {
                                        siteData: location,
                                        updated: Date.parse(new Date())
                                    }
                                }
                                customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                            }
                            let updates = localStorage.getItem('updates');
                            if (updates) {
                                try {
                                    let parsed = JSON.parse(updates);
                                    parsed['currentUserLocation'] = Date.parse(new Date());
                                    localStorage.setItem('updates', JSON.stringify(parsed));
                                } catch (error) {
                                    localStorage.removeItem('updates');
                                    console.error(`Error retrieving update times: ${error}`)
                                }
                            }
                        }
                    }
                },
                refreshStoresUnder100() {
                    let userLocation = this.location;
                    if (!userLocation?.latitude || !userLocation?.longitude) {
                        try {
                            userLocation = JSON.parse(localStorage.getItem('currentUserLocation') || 'null');
                        } catch (e) {
                            userLocation = null;
                        }
                    }

                    const baseLat = Number(userLocation?.latitude);
                    const baseLong = Number(userLocation?.longitude);
                    if (!Number.isFinite(baseLat) || !Number.isFinite(baseLong)) return;

                    this.nearestLocation(baseLat, baseLong);
                },
                updateNearestStore(data) {
                    const normalizedStore = this.normalizeNearestStore(data);
                    if (!normalizedStore?.node) return;
                    this.nearestStore = normalizedStore;
                    const vehicleSearch = window.vehicleSearch()
                    const provinceCode = normalizedStore?.node?.address?.provinceCode
                    if (vehicleSearch && provinceCode) {
                        vehicleSearch.regoState = provinceCode.toUpperCase()
                    }
                    this.backfillStoreContext(normalizedStore, this.isStoreLandingPage());
                    this.refreshStoresUnder100();
                },
                inputListener(liveInput, suburbOutput, postcodeOutput, postcodes, suburbs) {
                    if (isNaN(Number(liveInput))) {
                        if (liveInput.length > 2) {
                            const fuseOptions = {
                                includeScore: true,
                                keys: ['name'],
                                threshold: 0.4,
                                shouldSort: true
                            }
                            const fuse = new Fuse(suburbs, fuseOptions)
                            const result = fuse.search(`${liveInput}`)
                            suburbOutput.value = result.slice(0, 5);
                        }
                    } else {
                        if (liveInput.length > 1) {
                            let postSet = postcodes.filter(PC => PC.postcode.substring(0, liveInput.length) == liveInput && PC.latitude && PC.longitude);
                            postcodeOutput.value = postSet.slice(0, 5)
                        }
                    }
                },
                async getLocationInfo() {
                    const [postcodesResponse, suburbsResponse] = await Promise.all([fetch(pc), fetch(sub)]);
                    const postcodes = await postcodesResponse.json();
                    const suburbs = await suburbsResponse.json();
                    return [postcodes, suburbs];
                },
                async nearestLocation(latitude, longitude) {
                    let req = `{
	                locations(first:250,near:{latitude:${latitude},longitude:${longitude}},sortKey:DISTANCE) {
		                edges {
			                node {
                                id
				                address {
                                    phone
					                longitude
					                latitude
                                    formatted
                                    provinceCode
				                }
				                name
                                punctureRepair: metafield(namespace:"puncture_repair",key:"available") {
                                    value
                                }
                                closedFrom: metafield(namespace:"store",key:"closed_from") {
                                    value
                                }
                                closedTo: metafield(namespace:"store",key:"closed_to") {
                                    value
                                }
			                }
		                }
	                }
                }`
                    const opts = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query: req })
                    };

                    const storesResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, opts);
                    let stores = await storesResponse.json()
                    stores.data.locations.edges = stores?.data?.locations?.edges?.filter(edge => !edge?.node?.name?.includes("pre-order") && !edge?.node?.name?.includes("warehouse"))

                    let storeData = stores.data.locations.edges.map(store => {
                        store.node.phoneLink = `tel:${store.node.address.phone}`
                        store.node.storeLink = `${shopifyConfig.storeURL}/pages/${store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
                        store.node.directionLink = `https://maps.google.com.au/maps?q=${store.node.address.latitude},${store.node.address.longitude}&z=15`;
                        store.node.closedFrom = store.node.closedFrom?.value;
                        store.node.closedTo = store.node.closedTo?.value;
                        store.node.isClosed = this.isLocationClosed(store.node);
                        let distance = this.haversineFormula(Number(latitude), Number(longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                        return { ...store, distance };
                    });

                    this.storeList = storeData.slice(0, 3)

                    let nearStores = storeData.filter(store => Number(store.distance) < shopifyConfig.storeRadius)

                    this.storesWithinDistance = nearStores;
                    localStorage.setItem('storesUnder100', JSON.stringify(nearStores));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            storesUnder100: {
                                siteData: nearStores,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    let updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['storesUnder100'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    const nearRes = new Promise(async function (resolve, reject) {
                        resolve(storeData)
                    })
                    return nearRes;
                },
                locationSelect(locName, locLat, locLong) {
                    let item = {}
                    if (isNaN(Number(locName))) {
                        item.name = locName
                    } else {
                        item.postcode = locName
                    }
                    item.latitude = locLat
                    item.longitude = locLong
                    localStorage.setItem('currentUserLocation', JSON.stringify(item))
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            currentUserLocation: {
                                siteData: item,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    let updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['currentUserLocation'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    this.nearestLocation(item.latitude, item.longitude)
                    this.location = item;
                    item = {};
                },
                storeSelect(indexOrStore) {
                    if (typeof dataLayer != 'undefined') {
                        dataLayer.push({ 'event': 'storeSelected' });
                    }
                    const selectedStore = typeof indexOrStore === 'number'
                        ? this.storeList?.[indexOrStore]
                        : this.normalizeNearestStore(indexOrStore);
                    if (!selectedStore?.node) {
                        console.warn('[StoreDebug][storeSelect] Invalid store selection', indexOrStore);
                        return;
                    }
                    this.nearestStore = selectedStore
                    localStorage.setItem('currentNearestStore', JSON.stringify(selectedStore));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            currentNearestStore: {
                                siteData: selectedStore,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    let updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['currentNearestStore'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    if (typeof LogRocket != 'undefined') {
                        let logObject = {
                            name: selectedStore?.node?.name || '',
                            id: selectedStore?.node?.id?.replaceAll('gid://shopify/Location/', '') || ''
                        }
                        LogRocket.track('storeSelected', logObject);
                    }
                    this.backfillStoreContext(selectedStore, this.isStoreLandingPage());
                    this.refreshStoresUnder100();
                    let nearbyCount = 0;
                    try {
                        const parsed = JSON.parse(localStorage.getItem('storesUnder100') || '[]');
                        nearbyCount = Array.isArray(parsed) ? parsed.length : 0;
                    } catch (e) {
                        nearbyCount = 0;
                    }
                    const vehicleSearch = window.vehicleSearch()
                    const provinceCode = selectedStore?.node?.address?.provinceCode
                    if (vehicleSearch && provinceCode) {
                        vehicleSearch.regoState = provinceCode.toUpperCase()
                    }
                    const collection = window.collectionStore()
                    if (localStorage.getItem('storesUnder100')) {
                        collection.clearCache()
                    }
                },
                geolocation() {
                    if (!this.nearestStore || !this.location) {
                        if (navigator?.geolocation) {
                            navigator.permissions.query({ name: 'geolocation' })
                                .then(response => {
                                    if (response?.state == 'granted' || response?.state == 'prompt') {
                                        navigator.geolocation.getCurrentPosition(position => {
                                            if (position?.coords) {
                                                this.nearestLocation(position.coords.latitude, position.coords.longitude)
                                                    .then(object => {
                                                        const openStore = (object || []).find(s => !s?.node?.isClosed) || object?.[0]
                                                        this.storeSelect(openStore)
                                                    })
                                            }
                                        })
                                    }
                                })
                        }
                    }
                }
            },
        });
        window.sizeSearch = Pinia.defineStore('sizeSearch', {
            state: () => ({
                productType: Vue.ref('tyre'),
                tyreDetails: Vue.ref([
                    {
                        metafieldNamespace: 'wheel_tyre_spec',
                        metafieldKey: 'width',
                        options: [],
                        selected: false
                    },
                    {
                        metafieldNamespace: 'tyre_spec',
                        metafieldKey: 'aspect_ratio',
                        options: [],
                        selected: false
                    },
                    {
                        metafieldNamespace: 'wheel_tyre_spec',
                        metafieldKey: 'rim_diameter',
                        options: [],
                        selected: false
                    }
                ]),
                wheelDetails: Vue.ref([
                    {
                        metafieldNamespace: 'wheel_tyre_spec',
                        metafieldKey: 'rim_diameter',
                        options: [],
                        selected: false
                    },
                    {
                        metafieldNamespace: 'wheel_tyre_spec',
                        metafieldKey: 'width',
                        options: [],
                        selected: false
                    },
                    {
                        metafieldNamespace: 'wheel_spec',
                        metafieldKey: 'bolt',
                        options: [],
                        selected: false
                    },
                    {
                        metafieldNamespace: 'wheel_spec',
                        metafieldKey: 'pcd',
                        options: [],
                        selected: false
                    }
                ])
            }),
            actions: {
                normalizeOptionValue(rawValue, metafieldKey) {
                    if (rawValue === null || rawValue === undefined) return null;
                    const value = String(rawValue).trim();
                    if (!value) return null;

                    const numeric = Number(value);
                    const isNumeric = Number.isFinite(numeric);

                    if (metafieldKey === 'aspect_ratio') {
                        if (!isNumeric || numeric <= 0) return null;
                        return String(numeric);
                    }

                    if (isNumeric) return String(numeric);
                    return value;
                },
                dedupeAndSortOptions(values) {
                    const seen = new Set();
                    const cleaned = [];
                    for (let i = 0; i < values.length; i++) {
                        const value = values[i];
                        if (!seen.has(value)) {
                            seen.add(value);
                            cleaned.push(value);
                        }
                    }

                    const allNumeric = cleaned.every(v => Number.isFinite(Number(v)));
                    if (allNumeric) {
                        return cleaned.sort((a, b) => Number(a) - Number(b));
                    }
                    return cleaned.sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }));
                },
                setType(productType) {
                    this.productType = productType;
                },
                async getOptions(productType, filterIndex) {
                    let handle = ''
                    let filters = []
                    if (productType == 'tyre') {
                        handle = shopifyConfig.tyresCollection
                        if (filterIndex + 1 < this.tyreDetails.length) {
                            for (let i = filterIndex + 1; i < this.tyreDetails.length; i++) {
                                this.tyreDetails[i].options = [];
                                this.tyreDetails[i].selected = false;
                            }
                        }
                        for (let i = 0; i < filterIndex + 1; i++) {
                            if (this.tyreDetails[i].selected) {
                                filters.push(this.tyreDetails[i].selected)
                            }
                        }
                    } else if (productType == 'wheel') {
                        handle = shopifyConfig.wheelsCollection
                        if (filterIndex + 1 < this.wheelDetails.length) {
                            for (let i = filterIndex + 1; i < this.wheelDetails.length; i++) {
                                this.wheelDetails[i].options = [];
                                this.wheelDetails[i].selected = false;
                            }
                        }
                        for (let i = 0; i < filterIndex + 1; i++) {
                            if (this.wheelDetails[i].selected) {
                                filters.push(this.wheelDetails[i].selected)
                            }
                        }
                    } else {
                        console.log('Error: Invalid product type')
                        return
                    }
                    let stringFilters = ''
                    for (i = 0; i < filters.length; i++) {
                        if (i == 0) {
                            stringFilters = `{productMetafield:{namespace:"${filters[i].productMetafield.namespace}",key:"${filters[i].productMetafield.key}",value:"${filters[i].productMetafield.value}"}}`
                        } else {
                            stringFilters = `${stringFilters},{productMetafield:{namespace:"${filters[i].productMetafield.namespace}",key:"${filters[i].productMetafield.key}",value:"${filters[i].productMetafield.value}"}}`
                        }
                    }
                    let queryString = `{
	                    collection(handle:"${handle}") {
		                    products(first:1, filters:[${stringFilters}]) {
			                    filters {
				                    id
				                    type
				                    label
				                    values {
					                    id
					                    count
					                    input
				                    }
			                    }
		                    }
	                    }
                    }`
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query: queryString })
                    };
                    const optionReq = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => response.json())
                            .then(object => {
                                if (object?.data?.collection?.products?.filters) {
                                    resolve(object?.data?.collection?.products?.filters)
                                } else {
                                    console.log(`Error retrieving search options`)
                                }
                            })
                            .catch(err => {
                                console.log(`Error retrieving search options: ${err}`)
                            })
                    })
                    let filterOptions = await optionReq
                    if (productType == 'tyre') {
                        this.tyreDetails[filterIndex].options = [];
                        let selectedFilter = filterOptions.filter(node => node.id == `filter.p.m.${this.tyreDetails[filterIndex].metafieldNamespace}.${this.tyreDetails[filterIndex].metafieldKey}`)[0]
                        if (!selectedFilter?.values) return;
                        let validOptions = selectedFilter.values.filter(values => values.count > 0)
                        const normalized = [];
                        for (let i = 0; i < validOptions.length; i++) {
                            let parsed = null;
                            try {
                                parsed = JSON.parse(validOptions[i].input)?.productMetafield?.value;
                            } catch (e) {
                                parsed = null;
                            }
                            const normalizedValue = this.normalizeOptionValue(parsed, this.tyreDetails[filterIndex].metafieldKey);
                            if (normalizedValue !== null) normalized.push(normalizedValue);
                        }
                        this.tyreDetails[filterIndex].options = this.dedupeAndSortOptions(normalized);
                        if (filterIndex === 0) {
                            let groupedOptions = {
                                priorityGroup: ["265", "235", "225", "215", "205", "195", "185", "175"],
                                sizeGroup: [],
                                allSizes: []
                            }
                            groupedOptions.allSizes = groupedOptions.allSizes.concat(this.tyreDetails[filterIndex].options);
                            const sizeList = this.tyreDetails[filterIndex].options;
                            groupedOptions.priorityGroup.forEach((size) => {
                                const idx = sizeList.findIndex(s => s === size);
                                if (idx > -1) sizeList.splice(idx, 1);
                            })
                            sizeList.sort((a, b) => Number(b) - Number(a));
                            groupedOptions.sizeGroup = sizeList;
                            this.tyreDetails[filterIndex].options = groupedOptions;
                        }
                    } else if (productType == 'wheel') {
                        this.wheelDetails[filterIndex].options = [];
                        let selectedFilter = filterOptions.filter(node => node.id == `filter.p.m.${this.wheelDetails[filterIndex].metafieldNamespace}.${this.wheelDetails[filterIndex].metafieldKey}`)[0]
                        if (!selectedFilter?.values) return;
                        let validOptions = selectedFilter.values.filter(values => values.count > 0)
                        const normalized = [];
                        for (let i = 0; i < validOptions.length; i++) {
                            let parsed = null;
                            try {
                                parsed = JSON.parse(validOptions[i].input)?.productMetafield?.value;
                            } catch (e) {
                                parsed = null;
                            }
                            const normalizedValue = this.normalizeOptionValue(parsed, this.wheelDetails[filterIndex].metafieldKey);
                            if (normalizedValue !== null) normalized.push(normalizedValue);
                        }
                        this.wheelDetails[filterIndex].options = this.dedupeAndSortOptions(normalized);
                    }
                },
                //Use this function to select from dropdown type is wheel/tyre (string) filterIndex is the index of the dropdown, optionIndex is the index of the selected option
                selectOption(productType, filterIndex, optionIndex) {
                    let filters = []
                    if (productType == 'tyre') {
                        this.tyreDetails[filterIndex].selected = {
                            productMetafield: {
                                namespace: this.tyreDetails[filterIndex].metafieldNamespace,
                                key: this.tyreDetails[filterIndex].metafieldKey,
                                value: this.tyreDetails[filterIndex].options[optionIndex]
                            }
                        }
                        if (this.tyreDetails.length > filterIndex + 1) {
                            this.getOptions(productType, filterIndex + 1)
                        } else {
                            for (let i = 0; i < this.tyreDetails.length; i++) {
                                filters.push(this.tyreDetails[i].selected)
                                localStorage.setItem('searchWidgetFilters', JSON.stringify(filters))
                                window.location.href = `${shopifyConfig.storeURL}/collections/${shopifyConfig.tyresCollection}`
                            }
                        }
                    } else if (productType == 'wheel') {
                        this.wheelDetails[filterIndex].selected = {
                            productMetafield: {
                                namespace: this.wheelDetails[filterIndex].metafieldNamespace,
                                key: this.wheelDetails[filterIndex].metafieldKey,
                                value: this.wheelDetails[filterIndex].options[optionIndex]
                            }
                        }
                        if (this.wheelDetails.length > filterIndex + 1) {
                            this.getOptions(productType, filterIndex + 1)
                        } else {
                            for (let i = 0; i < this.wheelDetails.length; i++) {
                                filters.push(this.wheelDetails[i].selected)
                                localStorage.setItem('searchWidgetFilters', JSON.stringify(filters))
                                window.location.href = `${shopifyConfig.storeURL}/collections/${shopifyConfig.wheelsCollection}`
                            }
                        }
                    }
                }
            }
        });
        window.collectionStore = Pinia.defineStore('collection', {
            state: () => ({
                products: [],
                filters: {
                    category: 'All Products',
                    availability: false,
                    sort: 'mostRelevant'
                },
                filteredProducts: [],
                isDialogOpen: false,
                selectedProducts: [],  // ADD THIS
                isDrawerOpen: false,   // ADD THIS
                isCompareModalOpen: false,
                stockCache: [],
                showNoProdSection: false,
                bestsellerRefresh: null
            }),

            getters: {
                availableCategories: () => ['All Products', 'Performance', 'All-Terrain', 'Highway', 'Winter', 'Run-Flat']
            },

            actions: {
                setNoProdSection(show) {
                    this.showNoProdSection = !!show;
                },
                setBestsellerRefresh(fn) {
                    this.bestsellerRefresh = typeof fn === 'function' ? fn : null;
                },
                triggerBestsellerRefresh() {
                    if (typeof this.bestsellerRefresh === 'function') this.bestsellerRefresh();
                },
                loadCache() {
                    const rawCache = localStorage.getItem('stockCache');
                    if (!rawCache) {
                        return;
                    }
                    let cache = [];
                    try {
                        cache = JSON.parse(rawCache);
                    } catch (e) {
                        localStorage.removeItem('stockCache');
                        this.stockCache = [];
                        return;
                    }
                    if (!Array.isArray(cache)) {
                        localStorage.removeItem('stockCache');
                        this.stockCache = [];
                        return;
                    }
                    const now = Date.parse(new Date());
                    cache = cache.filter(product => product?.node?.stockExpiry > now);
                    this.stockCache = cache;
                    localStorage.setItem('stockCache', JSON.stringify(cache));
                },
                clearCache() {
                    this.stockCache = [];
                    localStorage.removeItem('stockCache');
                    const productEdges = Array.isArray(this.products?.edges)
                        ? this.products.edges
                        : (Array.isArray(this.products) ? this.products : []);
                    for (let i = 0; i < productEdges.length; i++) {
                        const node = productEdges[i]?.node || productEdges[i];
                        if (node?.stock) {
                            node.stock = [];
                            node.stockExpiry = 0;
                        }
                        if (node?.splitProduct?.node?.stock) {
                            node.splitProduct.node.stock = [];
                            node.splitProduct.node.stockExpiry = 0;
                        }
                    }
                    const stock = window.stock()
                    let qty = 4;
                    const vehicleSearch = window.vehicleSearch();
                    if (vehicleSearch?.vehicles?.[0]) {
                        if (typeof wheelCollection != 'undefined' && wheelCollection) {
                            if (vehicleSearch?.vehicles?.[0]?.fitmentInfo?.wheel_fitments?.[0]?.is_split) {
                                qty = 2;
                            }
                        } else if (typeof wheelCollection != 'undefined' && vehicleSearch?.vehicles?.[0]?.fitmentInfo?.tyre_fitments?.[0]?.is_split) {
                            qty = 2;
                        }
                    }
                    stock.PLPStockRequest(qty);
                },
                toggleDialog(open) {
                    this.isDialogOpen = open;
                },

                setFilter(filterType, value) {
                    this.filters[filterType] = value;
                    this.applyFilters();
                },

                applyFilters() {
                    let filtered = [...this.products];

                    if (this.filters.category !== 'All Products') {
                        filtered = filtered.filter(p => p.tags?.includes(this.filters.category));
                    }

                    if (this.filters.availability) {
                        filtered = filtered.filter(p => p.available);
                    }

                    const sortFns = {
                        priceLowHigh: (a, b) => a.price - b.price,
                        priceHighLow: (a, b) => b.price - a.price,
                        newest: (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    };

                    if (sortFns[this.filters.sort]) {
                        filtered.sort(sortFns[this.filters.sort]);
                    }

                    this.filteredProducts = filtered;
                },

                clearFilters() {
                    this.filters = {
                        category: 'All Products',
                        availability: false,
                        sort: 'mostRelevant'
                    };
                    this.applyFilters();
                },

                initializeProducts(products, activeCategory) {
                    this.products = products;
                    this.filters.category = activeCategory || 'All Products';
                    this.applyFilters();
                }
            }
        });
        window.compareStore = Pinia.defineStore('compareStore', {
            state: () => ({
                selectedProducts: [],
                isDrawerOpen: false,
                isCompareModalOpen: false,
                isCompareLimitDialogOpen: false,
                compareLimitDialogMessage: 'You can only compare up to 3 tyres',
                hydrated: false
            }),
            actions: {
                loadFromStorage() {
                    if (this.hydrated) return
                    this.hydrated = true
                    try {
                        const raw = localStorage.getItem('compareProducts')
                        const parsed = raw ? JSON.parse(raw) : []
                        const list = Array.isArray(parsed) ? parsed : (Array.isArray(parsed?.items) ? parsed.items : [])
                        this.selectedProducts = list
                            .map(p => ({ id: p?.id ?? p }))
                            .filter(p => p.id)
                    } catch (e) {
                        this.selectedProducts = []
                        localStorage.removeItem('compareProducts')
                    }
                    this.isDrawerOpen = false
                    this.persist()
                },
                persist() {
                    try {
                        localStorage.setItem('compareProducts', JSON.stringify(
                            this.selectedProducts.map(p => ({ id: p.id || p.node?.id }))
                        ))
                    } catch (e) {
                        localStorage.removeItem('compareProducts')
                    }
                },
                setDrawerOpen(open) {
                    this.isDrawerOpen = !!open
                    this.persist()
                },
                setProducts(products) {
                    this.selectedProducts = Array.isArray(products) ? products : []
                    this.persist()
                },
                clearAll() {
                    this.selectedProducts = []
                    this.isDrawerOpen = false
                    this.isCompareModalOpen = false
                    this.isCompareLimitDialogOpen = false
                    this.persist()
                },
                removeById(productId) {
                    const idx = this.selectedProducts.findIndex(p => p.id === productId)
                    if (idx > -1) {
                        this.selectedProducts.splice(idx, 1)
                    }
                    if (!this.selectedProducts.length) {
                        this.isDrawerOpen = false
                    }
                    this.persist()
                },
                openCompareDrawer() {
                    this.loadFromStorage()
                    this.setDrawerOpen(true)
                },
                showCompareLimitDialog(message) {
                    this.compareLimitDialogMessage = message || 'You can only compare up to 3 tyres'
                    this.isCompareLimitDialogOpen = true
                    this.persist()
                },
                closeCompareLimitDialog() {
                    this.isCompareLimitDialogOpen = false
                    this.persist()
                }
            }
        });
        // The compare modal is opened from several independent Vue apps (collection/
        // search/product pages), and <body> itself isn't inside any of their template
        // trees, so this class can't be a template :class binding — it's one store-level
        // watch instead of every page repeating its own classList side effect.
        Vue.watch(
            () => window.compareStore(window.VueAppGlobals.pinia).isCompareModalOpen,
            (isOpen) => {
                document.body.classList.toggle('compare-modal-open', !!isOpen);
            }
        );
        const safeParseHistoryJSON = (raw) => {
            try {
                const parsed = JSON.parse(raw || '[]');
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        };
        const cleanHistoryTitle = (title) => {
            return String(title || '').replace(/\s+[–-]\s+[^–-]+$/, '').trim();
        };
        window.historyStore = Pinia.defineStore('history', {
            state: () => ({
                items: [],
                metas: [],
                activeMenu: null,
                visibleCounts: { desktop: 5, mobile: 5 },
                pendingFetch: null,
                initialized: false
            }),
            getters: {
                hasHistory: (state) => state.items.length > 0,
                validHistoryCount(state) {
                    const invalid = state.metas.filter((meta) => !meta).length;
                    return state.items.length - invalid;
                },
                historyDisplayItems(state) {
                    const out = [];
                    for (let i = 0; i < state.metas.length; i++) {
                        const meta = state.metas[i];
                        if (!meta) continue;
                        const item = state.items[i];
                        const isPromo = !!meta.isPromo;
                        const unit = String(meta.type || '').toLowerCase().includes('wheel') ? 'wheel' : 'tyre';
                        out.push({
                            key: item.pathname,
                            url: item.url,
                            isCurrent: window.location.pathname === item.pathname,
                            image: meta.featured_image || '',
                            alt: cleanHistoryTitle(meta.title || item.title || 'Previously viewed product'),
                            title: cleanHistoryTitle(meta.title || item.title || 'Product'),
                            priceText: typeof meta.price === 'number' ? `${window.promo().priceFormat(meta.price / 100)} per ${unit}` : '',
                            isPromo,
                            promoText: isPromo ? (meta.promoTitle || meta.promoType || 'Promo') : '',
                            promoClass: isPromo && meta.promoColour ? 'header-history-promo--badge' : '',
                            promoStyle: isPromo && meta.promoColour ? { '--promo-bg': meta.promoColour } : null
                        });
                    }
                    return out;
                }
            },
            actions: {
                loadItems() {
                    if (this.initialized) return;
                    this.initialized = true;

                    const activeVehicleId = localStorage.getItem('activeVehicleId');
                    let rawItems = activeVehicleId ? safeParseHistoryJSON(localStorage.getItem(`${activeVehicleId}history`)) : [];
                    if (!rawItems.length) rawItems = safeParseHistoryJSON(localStorage.getItem('history'));

                    const seen = new Set();
                    const items = [];
                    for (const raw of rawItems) {
                        const rawUrl = String(raw?.url || '').trim();
                        if (!rawUrl) continue;
                        let parsed;
                        try {
                            parsed = new URL(rawUrl, window.location.origin);
                        } catch (e) {
                            continue;
                        }
                        if (!/^\/products\/[^/]+/i.test(parsed.pathname)) continue;
                        const key = parsed.pathname.toLowerCase();
                        if (seen.has(key)) continue;
                        seen.add(key);
                        items.push({
                            title: String(raw?.title || '').trim(),
                            url: parsed.toString(),
                            pathname: parsed.pathname,
                            handle: decodeURIComponent(parsed.pathname.split('/products/')[1]?.split('/')[0] || '')
                        });
                        if (items.length >= 50) break;
                    }
                    this.items = items;
                },
                async fetchHistoryMeta(handles) {
                    if (!handles.length) return handles.map(() => null);
                    if (!shopifyConfig?.storeURL || !shopifyConfig?.apiVersion || !shopifyConfig?.PLP) {
                        return handles.map(() => null);
                    }
                    try {
                        const fields = `
                            title vendor productType
                            featuredImage { url(transform: {maxWidth: 300}) }
                            priceRange { minVariantPrice { amount } }
                            collections(first: 20) {
                                edges {
                                    node {
                                        title: metafield(namespace: "promotion", key: "title") { value }
                                        type: metafield(namespace: "promotion", key: "type") { value }
                                        colour: metafield(namespace: "promotion", key: "colour") { value }
                                    }
                                }
                            }
                        `;
                        const aliases = handles.map((handle, i) => `p${i}: product(handle: "${handle}") { ${fields} }`).join('\n');
                        const response = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                            },
                            body: JSON.stringify({ query: `{ ${aliases} }` })
                        });
                        if (!response.ok) return handles.map(() => null);
                        const payload = await response.json();
                        return handles.map((_handle, i) => {
                            const product = payload?.data?.[`p${i}`];
                            if (!product) return null;
                            const edges = product.collections?.edges || [];
                            const promoEdge = edges.find((e) => e?.node?.type?.value);
                            const promoType = String(promoEdge?.node?.type?.value || '').trim();
                            const promoTitle = String(promoEdge?.node?.title?.value || '').trim();
                            const promoColour = String(promoEdge?.node?.colour?.value || '').trim();
                            return {
                                title: product.title,
                                vendor: product.vendor,
                                type: product.productType,
                                featured_image: product.featuredImage?.url || '',
                                price: Math.round(parseFloat(product.priceRange?.minVariantPrice?.amount || '0') * 100),
                                isPromo: Boolean(promoType),
                                promoType,
                                promoTitle,
                                promoColour
                            };
                        });
                    } catch (e) {
                        return handles.map(() => null);
                    }
                },
                async ensureMetas(upTo) {
                    const need = Math.min(upTo, this.items.length);
                    if (this.metas.length >= need) return;
                    if (!this.pendingFetch) {
                        const from = this.metas.length;
                        const batch = this.items.slice(from, need);
                        this.pendingFetch = this.fetchHistoryMeta(batch.map((item) => item.handle)).then((results) => {
                            this.metas.push(...results);
                            this.pendingFetch = null;
                        });
                    }
                    await this.pendingFetch;
                },
                async toggleMenu(menuId) {
                    if (this.activeMenu === menuId) {
                        this.activeMenu = null;
                        return;
                    }
                    this.activeMenu = menuId;
                    await this.ensureMetas(this.visibleCounts[menuId] || 5);
                },
                async loadMoreHistory(menuId) {
                    this.visibleCounts[menuId] = Math.min((this.visibleCounts[menuId] || 5) + 5, this.items.length);
                    await this.ensureMetas(this.visibleCounts[menuId]);
                }
            }
        });
        window.uiState = Pinia.defineStore('uiState', {
            state: () => ({
                vehicleDropdownOpen: Vue.ref(false),
                vehicleModalOpen: Vue.ref(false),
            }),
            actions: {
                setVehicleDropdownOpen(open) {
                    this.vehicleDropdownOpen = !!open;
                },
                setVehicleModalOpen(open) {
                    this.vehicleModalOpen = !!open;
                },
            },
        });
        window.vehicleSearch = Pinia.defineStore('vehicleSearch', {
            state: () => ({
                vehicles: Vue.ref([]),
                releaseVersion: Vue.ref('1.0.0'),
                expiry: Vue.ref(fitmentExpiry),
                vehicleAgeReversal: Vue.ref(vehicleAgeReversal),
                products: Vue.ref([]),
                loading: Vue.ref(true),
                regoLPN: Vue.ref(''),
                regoState: Vue.ref(''),
                vehicleCall: Vue.ref(false),
                fitmentRequests: Vue.ref({}),
                activeVehicleId: localStorage.getItem('activeVehicleId') || '',
                vehicleSelector: Vue.ref([
                    {
                        trait: 'makes',
                        options: false,
                        selectedOption: false
                    },
                    {
                        trait: 'years',
                        options: false,
                        selectedOption: false
                    },
                    {
                        trait: 'models',
                        options: false,
                        selectedOption: false
                    },
                    {
                        trait: 'series',
                        options: false,
                        selectedOption: false
                    }
                ]),
            }),
            actions: {
                clubRegexes(rego, state) {
                    const regexes = {
                        VIC: /^(?:\d{5}H|\d{4}H\d|\d{3}H\d{2}|M\d{5}|M\d{4}H|\d{4}HO)$/,
                        NSW: /^(?:\d{5}H|\d{4}H\d|\d{3}H\d{2}|M\d{5}|M\d{4}H|\d{1,5}[JKHEFCDR]|\d{1,5}(?:HC|MC)|H\d{1,4}|\d{1,5})$/,
                        QLD: /^\d{5}H$/,
                        WA: /^\d{1,5}(?:HC|MC)$/,
                        TAS: /^H\d{1,4}$/,
                        ACT: /^\d{1,5}$/,
                        NT: /^\d{1,5}$/
                    }
                    return regexes[state].test(rego);
                },
                async retrieveSelectorOptions(traitIndex) {
                    if (traitIndex == 0) {
                        if (localStorage.getItem('makes')) {
                            try {
                                let makes = JSON.parse(localStorage.getItem('makes'));
                                if (makes.expiry > Date.parse(new Date())) {
                                    this.vehicleSelector[traitIndex].options = makes.options;
                                    return;
                                } else {
                                    localStorage.removeItem('makes');
                                }
                            } catch (err) {
                                localStorage.removeItem('makes');
                            }
                        }
                    }
                    if (traitIndex != 1) {
                        let endpoint = `${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}vehicle/${this.vehicleSelector[traitIndex].trait}`
                        if (traitIndex == 2) {
                            endpoint = `${endpoint}/${this.vehicleSelector[0].selectedOption.id}?year=${this.vehicleSelector[1].selectedOption}`
                        } else if (traitIndex != 0) {
                            endpoint = `${endpoint}/${this.vehicleSelector[traitIndex - 1].selectedOption.id}?year=${this.vehicleSelector[1].selectedOption}`
                        }
                        const options = {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                "x-api-version": shopifyConfig.azureVersion
                            }
                        };
                        const optionReq = new Promise(function (resolve, reject) {
                            fetch(endpoint, options)
                                .then(response => response.json())
                                .then(object => {
                                    resolve(object)
                                })
                                .catch(err => {
                                    console.log(`Error retrieving ${this.vehicleSelector[traitIndex].trait}: ${err}`)
                                })
                        })
                        let traitOptions = await optionReq;
                        traitOptions.sort((a, b) => {
                            return a.display_name.localeCompare(b.display_name);
                        });
                        this.vehicleSelector[traitIndex].options = traitOptions;
                        if (traitIndex == 0) {
                            let expiry = Date.parse(new Date()) + (60 * 60 * 1000);
                            localStorage.setItem('makes', JSON.stringify({
                                options: traitOptions,
                                expiry: expiry
                            }));
                        }
                    } else if (traitIndex == 1) {
                        let currentYear = new Date().toISOString().substring(0, 4);
                        if (this?.vehicleSelector[0]?.selectedOption?.year_to > Number(currentYear) || this?.vehicleSelector[0]?.selectedOption?.year_to == null || this?.vehicleSelector[0]?.selectedOption?.year_to == "Current") {
                            this.vehicleSelector[0].selectedOption.year_to = Number(currentYear);
                        }
                        let timeOptions = []
                        for (let i = this.vehicleSelector[0].selectedOption.year_from; i < this.vehicleSelector[0].selectedOption.year_to + 1; i++) {
                            timeOptions.push(i)
                        }
                        this.vehicleSelector[1].options = timeOptions
                    }
                },
                selectTrait(traitIndex, optionIndex) {
                    this.vehicleSelector[traitIndex].selectedOption = this.vehicleSelector[traitIndex].options[optionIndex];
                    if (traitIndex < this.vehicleSelector.length) {
                        for (let i = traitIndex + 1; i < this.vehicleSelector.length; i++) {
                            this.vehicleSelector[i].options = false
                            this.vehicleSelector[i].selectedOption = false
                        }
                    }
                    if (traitIndex < this.vehicleSelector.length - 1) {
                        this.retrieveSelectorOptions(traitIndex + 1)
                    } else if (traitIndex == this.vehicleSelector.length - 1) {
                        this.getFitment(this.vehicleSelector[traitIndex].selectedOption.id)
                            .then(object => {
                                if (object == 'fitFail') {
                                    console.log('Error finding fitment')
                                } else {
                                    let fitVehicle = {
                                        "source": 1,
                                        "id": this.vehicleSelector[3].selectedOption.id,
                                        "vehicle_id": this.vehicleSelector[3].selectedOption.id,
                                        "display_name": this.vehicleSelector[3].selectedOption.display_name,
                                        "series": object.series,
                                        "grade": object.grade,
                                        "body": object.body,
                                        "version": object.version,
                                        "is_run_flat": object.is_run_flat,
                                        "is_electric": object.is_electric,
                                        "year_from": object.year_from,
                                        "year_to": object.year_to,
                                        "logo_url": this.vehicleSelector[0].selectedOption.logo_url,
                                        "make": {
                                            "id": this.vehicleSelector[0].selectedOption.id,
                                            "display_name": this.vehicleSelector[0].selectedOption.display_name
                                        },
                                        "model": {
                                            "id": this.vehicleSelector[2].selectedOption.id,
                                            "display_name": this.vehicleSelector[2].selectedOption.display_name
                                        },
                                        "rego": null,
                                        "regoState": null,
                                        "vehicle_category": object.vehicle_category
                                    }
                                    if (!object?.tyre_fitments[0]?.is_oe) {
                                        for (i = 1; i < object.tyre_fitments.length; i++) {
                                            if (object.tyre_fitments[i].is_oe) {
                                                let oeFit = object.tyre_fitments[i]
                                                object.tyre_fitments.splice(i, 1)
                                                object.tyre_fitments.unshift(oeFit)
                                                break
                                            }
                                        }
                                    }
                                    if (object.tyre_fitments[0]?.f_tyres) {
                                        object.tyre_fitments[0].f_tyres.filters = this.createFitFilters(object.tyre_fitments[0].f_tyres)
                                        if (object.tyre_fitments[0].is_split && object.tyre_fitments[0].r_tyres) {
                                            object.tyre_fitments[0].r_tyres.filters = this.createFitFilters(object.tyre_fitments[0].r_tyres)
                                        }
                                    }
                                    //move OE wheels to front of array
                                    if (!object?.wheel_fitments[0]?.is_oe) {
                                        for (i = 1; i < object.wheel_fitments.length; i++) {
                                            if (object?.wheel_fitments[i]?.is_oe) {
                                                let oeFit = object.wheel_fitments[i]
                                                object.wheel_fitments.splice(i, 1)
                                                object.wheel_fitments.unshift(oeFit)
                                                break
                                            }
                                        }
                                    }
                                    if (object?.wheel_fitments[0]?.f_wheels?.filters) {
                                        object.wheel_fitments[0].f_wheels.filters = this.createFitFilters(object.wheel_fitments[0].f_wheels)
                                    }
                                    if (object?.wheel_fitments[0]?.is_split) {
                                        object.wheel_fitments[0].r_wheels.filters = this.createFitFilters(object.wheel_fitments[0].r_wheels)
                                    }
                                    fitVehicle.fitmentInfo = object;
                                    fitVehicle.fitmentInfo.version = this.releaseVersion;
                                    fitVehicle.fitmentInfo.expiry = Date.parse(new Date()) + (24 * (60 * (60 * 1000)));
                                    fitVehicle.manufactureYear = this.vehicleSelector[1].selectedOption;
                                    let preIndex = this.vehicles.findIndex(vehicle => vehicle.id == fitVehicle.id);
                                    if (preIndex > -1) {
                                        this.deleteVehicle(this.vehicles[preIndex]);
                                    }
                                    this.addVehicle(fitVehicle);
                                }
                            })
                    }
                },
                updateProducts(data) {
                    this.products.concat(data)
                    this.loading = false
                },
                async addVehicle(data) {
                    localStorage.removeItem('questionnaire');
                    const regoValue = this.regoLPN?.value || this.regoLPN || '';
                    const regoStateValue = this.regoState?.value || this.regoState || '';
                    if (!data.rego && regoValue) {
                        data.rego = regoValue;
                    }
                    if (!data.regoState && regoStateValue) {
                        data.regoState = regoStateValue;
                    }
                    const normalizedRego = String(data.rego || '').trim().toUpperCase();
                    const normalizedState = String(data.regoState || '').trim().toUpperCase();
                    if (data?.fitmentInfo?.categories) {
                        data.categories = data.fitmentInfo.categories
                    }
                    if (data.categories) {
                        let categories = await this.fetchCategories(data.categories)
                        data.additions = categories
                    }

                    const duplicateIndexes = [];
                    for (let i = 0; i < this.vehicles.length; i++) {
                        const current = this.vehicles[i];
                        const sameId = data?.id != null && String(current?.id) === String(data.id);
                        const sameRegoState =
                            normalizedRego &&
                            normalizedState &&
                            String(current?.rego || '').trim().toUpperCase() === normalizedRego &&
                            String(current?.regoState || '').trim().toUpperCase() === normalizedState;
                        if (sameId || sameRegoState) {
                            duplicateIndexes.push(i);
                        }
                    }
                    for (let i = duplicateIndexes.length - 1; i >= 0; i--) {
                        this.vehicles.splice(duplicateIndexes[i], 1);
                    }

                    this.vehicles.unshift(data);
                    if (this.vehicles.length > 3) this.vehicles.splice(3);
                    localStorage.setItem('vehicles', JSON.stringify(this.vehicles));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            vehicles: {
                                siteData: this.vehicles,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    let updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['vehicles'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    localStorage.removeItem('searchWidgetFilters');
                    if (typeof LogRocket != 'undefined') {
                        let logObject = {
                            make: this?.vehicles?.[0]?.make?.display_name || '',
                            model: this?.vehicles?.[0]?.model?.display_name || '',
                            series: this?.vehicles?.[0]?.series?.display_name != '' ? this?.vehicles?.[0]?.series?.display_name : this?.vehicles?.[0]?.fitmentInfo?.display_name || '',
                            year: this?.vehicles?.[0]?.manufactureYear || '',
                            rego: regoValue || '',
                            regoState: regoStateValue || ''
                        }
                        LogRocket.track('vehicleAdded', logObject);
                    }
                    if (typeof dataLayer != 'undefined') {
                        dataLayer.push({ 'event': 'vehicleSelected' });
                    }
                    if (this?.vehicles?.[0]?.id) {
                        this.setActiveVehicle(this.vehicles[0].id)
                    }
                    const addPromise = new Promise(function (resolve) {
                        resolve(true)
                    })
                    return addPromise
                },
                deleteVehicle(data) {
                    const index = this.vehicles.indexOf(data);
                    if (index > -1) {
                        this.vehicles.splice(index, 1);
                        localStorage.setItem('vehicles', JSON.stringify(this.vehicles));
                        let updates = localStorage.getItem('updates');
                        if (updates) {
                            try {
                                let parsed = JSON.parse(updates);
                                parsed['vehicles'] = Date.parse(new Date());
                                localStorage.setItem('updates', JSON.stringify(parsed));
                            } catch (error) {
                                localStorage.removeItem('updates');
                                console.error(`Error retrieving update times: ${error}`)
                            }
                        }
                        if (index === 0) {
                            localStorage.removeItem('questionnaire');
                        }
                    }
                },
                async loadVehicleArray() {
                    if (this.vehicles.length == 0 && localStorage.getItem('vehicles') && JSON.parse(localStorage.getItem('vehicles')).length > 0) {
                        this.vehicles = JSON.parse(localStorage.getItem('vehicles'));
                        this.regoState = JSON.parse(localStorage.getItem('vehicles'))[0].regoState;
                    } else if (localStorage.getItem('currentNearestStore')) {
                        this.regoState = JSON.parse(localStorage.getItem('currentNearestStore')).node.address.provinceCode
                    }
                    for (let i = 0; i < this.vehicles.length; i++) {
                        if (this.vehicles[i].fitmentInfo.expiry < Date.parse(new Date())) {
                            let newFit = await this.getFitment(this.vehicles[i].id)
                            if (newFit == 'fitFail') {
                                for (let q = 0; q < 5; q++) {
                                    newFit = await this.getFitment(this.vehicles[i].id)
                                    if (newFit != 'fitFail') {
                                        break
                                    }
                                }
                            }
                            if (newFit != 'fitFail') {
                                this.vehicles[i].fitmentInfo = newFit
                                this.vehicles[i].fitmentInfo.expiry = Date.parse(new Date()) + (this.expiry * (60 * (60 * 1000)))
                                this.vehicles[i].fitmentInfo.version = this.releaseVersion
                            }
                        }
                    }
                },
                async getVehicle(token) {
                    if (!this.regoLPN || !this.regoState) return;
                    if (typeof dataLayer != 'undefined') {
                        dataLayer.push({ 'event': 'regoSearched' });
                    }
                    let state = this.regoState
                    let rego = this.regoLPN
                    const vehicleCall = new Promise(function (resolve, reject) {
                        let fetchString = `${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}vehicle/live/lpn?lpn=${rego}&state=${state}`;
                        if (shopifyConfig.storeURL == "https://bobjane-prod.myshopify.com" || shopifyConfig.storeURL == "https://www.bobjane.com.au") {
                            fetchString = `${shopifyConfig.storeURL}${shopifyConfig.appEndpoint}vehicle/lpn?lpn=${rego}&state=${state}`;
                        }
                        const vehicleResponse = fetch(fetchString, {
                            method: 'GET', headers: { "x-api-version": shopifyConfig.azureVersion, 'recaptcha-token': token }
                        })
                            .then(response => {
                                if (response.status < 400 && response.status != 218) {
                                    return response.json()
                                } else {
                                    resetRecaptcha();
                                    new Error("Could not locate vehicle")
                                    return 'regoFail'
                                }
                            })
                            .then(object => {
                                resetRecaptcha()
                                resolve(object);
                            })
                    });
                    resetRecaptcha()
                    let newVehicle = await vehicleCall;
                    if (newVehicle?.year_to == null || newVehicle?.year_to == 2099) {
                        newVehicle.year_to = "Current"
                    }
                    this.vehicleCall = newVehicle
                    return
                },
                manYear(vehicle) {
                    let yearSuffix
                    if (vehicle.display_name.includes('MY')) {
                        yearSuffix = vehicle.display_name.split('MY')[1]
                    } else if (vehicle.display_name.includes('my')) {
                        yearSuffix = vehicle.display_name.split('my')[1]
                    } else {
                        return vehicle.year_from
                    }
                    let endYear = vehicle.year_to;
                    if (endYear == 'Current' || endYear == null || endYear == 2099) {
                        endYear = new Date().toISOString().substring(0, 4);
                    }
                    for (let i = vehicle.year_from; i < (endYear + 1); i++) {
                        if (Number(`${i}`.substring(2, 4)) == Number(yearSuffix)) {
                            return i
                        }
                    }
                    return vehicle.year_from
                },
                async getFitment(vehicleID) {
                    const vehicleCall = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.appEndpoint}vehicle/fitments/${vehicleID}`, { method: 'GET', headers: { "x-api-version": shopifyConfig.azureVersion } })
                            .then(response => {
                                if (response.status < 400) {
                                    return response.json()
                                } else {
                                    resolve('fitFail')
                                }
                            })
                            .then(object => {
                                if (!object?.tyre_fitments[0]?.is_oe) {
                                    for (i = 1; i < object?.tyre_fitments?.length; i++) {
                                        if (object?.tyre_fitments[i]?.is_oe) {
                                            let oeFit = object.tyre_fitments[i]
                                            object.tyre_fitments.splice(i, 1)
                                            object.tyre_fitments.unshift(oeFit)
                                            break
                                        }
                                    }
                                }
                                if (!object?.wheel_fitments[0]?.is_oe) {
                                    for (i = 1; i < object.wheel_fitments.length; i++) {
                                        if (object.wheel_fitments[i].is_oe) {
                                            let oeFit = object.wheel_fitments[i]
                                            object.wheel_fitments.splice(i, 1)
                                            object.wheel_fitments.unshift(oeFit)
                                            break
                                        }
                                    }
                                }
                                if (object?.year_to == null || object?.year_to == 2099) {
                                    object.year_to = "Current"
                                }
                                resolve(object);
                                reject('fitFail');
                            })
                    });
                    return vehicleCall
                },
                createFitFilters(fitment) {
                    let fitFilters = [];
                    if (fitment?.matches?.length) { }
                    for (let i = 0; i < fitment?.matches?.length; i++) {
                        fitFilters.push(`{productMetafield:{namespace:"wts",key:"sf",value:"${fitment.matches[i]}"}}`)
                    }
                    return fitFilters
                },
                updateTyreFitment(data) {
                    localStorage.removeItem('questionnaire');
                    if (this.vehicles[0]?.fitmentInfo?.tyre_fitments) {
                        this.vehicles[0].fitmentInfo.tyre_fitments = data;
                        const tyreDesc = data?.[0]?.f_tyres?.desc || data?.[0]?.f_tyres?.full_desc || '';
                        const tyreRimMatch = String(tyreDesc).toUpperCase().match(/R(\d{2})\b/);
                        const tyreRim = tyreRimMatch ? Number(tyreRimMatch[1]) : null;
                        const wheelFits = this.vehicles[0]?.fitmentInfo?.wheel_fitments || [];
                        if (tyreRim && wheelFits.length > 1) {
                            const wheelIndex = wheelFits.findIndex((wf) => {
                                const wheelDesc = wf?.f_wheels?.desc || wf?.f_wheels?.full_desc || '';
                                const wheelMatch = String(wheelDesc).match(/(\d{2})(?:\s*inch|\b)/i);
                                return wheelMatch && Number(wheelMatch[1]) === tyreRim;
                            });
                            if (wheelIndex > 0) {
                                const wheelFit = wheelFits[wheelIndex];
                                wheelFits.splice(wheelIndex, 1);
                                wheelFits.unshift(wheelFit);
                            }
                        }
                        localStorage.setItem('vehicles', JSON.stringify(this.vehicles));
                        if (localStorage.getItem(btoa('user'))) {
                            const customerTools = window.customerTools();
                            const submission = {
                                vehicles: {
                                    siteData: this.vehicles,
                                    updated: Date.parse(new Date())
                                }
                            }
                            customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                        }
                        let updates = localStorage.getItem('updates');
                        if (updates) {
                            try {
                                let parsed = JSON.parse(updates);
                                parsed['vehicles'] = Date.parse(new Date());
                                localStorage.setItem('updates', JSON.stringify(parsed));
                            } catch (error) {
                                localStorage.removeItem('updates');
                                console.error(`Error retrieving update times: ${error}`)
                            }
                        }
                    }
                },
                async fetchCategories(catArray) {
                    let qList = ''
                    let prodBlock = `edges {
			                        node {
				                        id
				                        handle
				                        title
				                        images(first:1) {
					                        edges {
						                        node {
							                        url
							                        altText
						                        }
					                        }
				                        }
				                        variants (first:1) {
					                        edges {
						                        node {
							                        id
							                        price {
								                        amount
							                        }
                        						}
					                        }
				                        }
                        			}
		                        }
	                        }`

                    for (let i = 0; i < catArray.length; i++) {
                        if (catArray[i].key === 'fq') {
                            continue;
                        }
                        if (qList == '') {
                            qList = `${catArray[i].key}: products(first:1,query:"tag:'${catArray[i].key}:${catArray[i].value}'") {
                            ${prodBlock}`
                        } else {
                            qList = `${qList}${catArray[i].key}: products(first:1,query:"tag:'${catArray[i].key}:${catArray[i].value}'") {
                            ${prodBlock}`
                        }
                    }
                    let queryString = {
                        query: `{
	                        ${qList}
                        }`
                    }
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify(queryString)
                    };
                    try {
                        const getCategories = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options);
                        const categories = await getCategories.json();
                        const promo = window.promo();
                        let catSet = {}
                        for (let i = 0; i < catArray.length; i++) {
                            catSet[catArray[i].key] = {
                                title: categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.title || "",
                                url: `${shopifyConfig.storeURL}/products/${categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.handle}` || "",
                                variantGid: categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.variants?.edges?.[0]?.node?.id || "",
                                price: promo.priceFormat(categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.variants?.edges?.[0]?.node?.price?.amount) || "",
                                imageUrl: categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.images?.edges?.[0]?.node?.url || "",
                                imageAltText: categories?.data?.[catArray[i].key]?.edges?.[0]?.node?.images?.edges?.[0]?.node?.altText || "",
                                alignment: [catArray[i].key] == 'wa',
                                puncture: [catArray[i].key] == 'pr',
                                service: true
                            }
                        }
                        return catSet
                    } catch (error) {
                        console.log('Error fetching categories', error)
                        return {
                            "error": error
                        }
                    }
                },
                setActiveVehicle(id) {
                    this.activeVehicleId = String(id);
                    localStorage.setItem('activeVehicleId', String(id));
                },
                clearActiveVehicle() {
                    this.activeVehicleId = '';
                    localStorage.removeItem('activeVehicleId');
                },
                openVehicleSearch() {
                    window.uiState().setVehicleDropdownOpen(true);
                }
            }
        });
        window.scrollState = Pinia.defineStore('scrollState', {
            state: () => ({
                //Possible values: 'mobile' (string), 'desktop' (string) & false (boolean)
                device: Vue.ref(false),
                //Possible values: 'up' (string), 'down' (string) & false (boolean)
                scrollDirection: Vue.ref(false),
                //Possible values: true (boolean) & false (boolean)
                scrolling: Vue.ref(false)
            }),
            actions: {
                initiateScrollState() {
                    let scrollTimeoutID
                    let scrollPosition = window.scrollY
                    if (window.innerWidth > 768) {
                        this.device = 'desktop'
                    } else {
                        this.device = 'mobile'
                    }
                    window.addEventListener('resize', function () {
                        if (window.innerWidth > 768) {
                            this.device = 'desktop'
                        } else {
                            this.device = 'mobile'
                        }
                    })
                    window.addEventListener('scroll', function () {
                        this.scrolling = true;
                        if (scrollPosition < window.scrollY) {
                            this.scrollDirection = 'down';
                        } else if (scrollPosition > window.scrollY) {
                            this.scrollDirection = 'up';
                        }
                        scrollPosition == window.scrollY
                        if (scrollTimeoutID) {
                            clearTimeout(scrollTimeoutID);
                        }
                        scrollTimeoutID = setTimeout(() => {
                            this.scrolling = false;
                        }, 500)
                        if (window.innerWidth > 768) {
                            this.device = 'desktop'
                        } else {
                            this.device = 'mobile'
                        }
                    })
                }
            }
        });
        window.storeHistory = Pinia.defineStore('storeHistory', {
            state: () => ({
                history: Vue.ref([])
            }),
            actions: {
                addToHistory() {
                    const vehicleSearch = window.vehicleSearch()
                    if (vehicleSearch?.vehicles[0] && localStorage.getItem(`${vehicleSearch?.vehicles[0].id}history`)) {
                        this.history = JSON.parse(localStorage.getItem(`${vehicleSearch?.vehicles[0].id}history`))
                    } else if (localStorage.getItem(`history`)) {
                        this.history = JSON.parse(localStorage.getItem(`history`))
                    }
                    let historyItem = {
                        title: document.title,
                        url: window.location.href
                    }
                    this.history.unshift(historyItem)
                    if (this.history.length > 30) this.history = this.history.slice(0, 30)
                    if (vehicleSearch?.vehicles[0]) {
                        localStorage.setItem(`${vehicleSearch?.vehicles[0].id}history`, JSON.stringify(this.history))
                    } else {
                        localStorage.setItem(`history`, JSON.stringify(this.history))
                    }
                }
            }
        });
        window.cartTools = Pinia.defineStore('cartTools', {
            state: () => ({
                pending: Vue.ref(false),
                cartData: Vue.ref(false),
                cartContent: Vue.ref(false),
                showCart: Vue.ref(false),
                justAdded: Vue.ref(false),
                justAddedIsTyre: Vue.ref(false),
                openCheckout: Vue.ref(false),
                vehicleLPN: Vue.ref(''),
                vehicleState: Vue.ref(''),
                vehicleMakeModel: Vue.ref(''),
                storeNotes: Vue.ref(''),
                fitmentDate: Vue.ref(false),
                fitmentTime: Vue.ref(false),
                confirmTyreWheelSize: Vue.ref(false),
                confirmStockTerms: Vue.ref(false),
                enableProceedToPayment: Vue.ref(false),
                isProceedingToPayment: Vue.ref(false),
                unknownRego: Vue.ref(false),
                cartString: `cart {
                    id
			        checkoutUrl
			        totalQuantity
                    attribute(key:"logrocket") {
                        value
                    }
                    attributes {
                        key
                        value
                    }
			        cost {
				        totalAmount {
					        amount
				        }
				        subtotalAmount {
					        amount
				        }
			        }
			        lines(first:50) {
				        edges {
					        node {
						        id
						        merchandise {
							        ... on ProductVariant {
                                        id
								        sku
								        image {
									        altText
									        url
								        }
								        product {
                                            id
									        title
									        handle
                                            collections(first:50) {
                                                edges {
                                                    node {
                                                        id
                                                        title: metafield(namespace:"promotion",key:"title") {
										                    value
									                    }
                                                        type: metafield(namespace:"promotion",key:"type") {
										                    value
									                    }
                                                        value: metafield(namespace:"promotion",key:"value") {
										                    value
									                    }
                                                    }
                                                }    
                                            }
                                            metafield(namespace:"wts",key:"sf") {
                                                value
                                            }
                                            category {
                                                name
                                            }
								        }
								        price {
									        amount
								        }
							        }
						        }
						        quantity
						        discountAllocations {
							        discountedAmount {
								        amount
							        }
						        }
                                cost {
                                    subtotalAmount {
                                        amount
                                    }
                                    totalAmount {
                                        amount
                                    }
                                }
					        }
				        }
			        }
                }
                userErrors {
                    field
                    message
                }
                warnings {
			        code
                    message
			        target
                }
            }
        }`
            }),
            actions: {
                discountMangement(cartObject) {
                    let splices = []
                    let duplicates = cartObject.lines.edges.filter((edge, index) => cartObject.lines.edges.indexOf(item => item.node.merchandise.id == edge.node.merchandise.id) !== index)
                    for (let i = 0; i < duplicates.length; i++) {
                        if (duplicates[i]?.node?.cost?.subtotalAmount.amount != duplicates[i]?.node?.cost?.totalAmount.amount && duplicates[i]?.node?.cost?.totalAmount.amount == "0.0") {
                            let trueIdx = cartObject.lines.edges.findIndex(item => item.node.merchandise.id == duplicates[i].node.merchandise.id);
                            let discIdx = cartObject.lines.edges.findIndex(item => item.node.id == duplicates[i].node.id);
                            if (trueIdx === discIdx) {
                                continue;
                            }
                            if (trueIdx > -1 && discIdx > -1) {
                                cartObject.lines.edges[trueIdx].node.cost.subtotalAmount.amount = (Number(cartObject.lines.edges[trueIdx].node.cost.subtotalAmount.amount) + Number(cartObject.lines.edges[discIdx].node.cost.subtotalAmount.amount)).toFixed(2).toString();
                                cartObject.lines.edges[trueIdx].node.cost.totalAmount.amount = (Number(cartObject.lines.edges[trueIdx].node.cost.totalAmount.amount) + Number(cartObject.lines.edges[discIdx].node.cost.totalAmount.amount)).toFixed(2).toString();
                                cartObject.lines.edges[trueIdx].node.discountAllocations.concat(cartObject.lines.edges[discIdx].node.discountAllocations)
                                cartObject.lines.edges[discIdx].node.cost.subtotalAmount.amount = "0.0"
                                cartObject.lines.edges[discIdx].node.cost.subtotalAmount.amount = "0.0"
                                continue;
                            }
                        }
                    }
                    return cartObject
                },
                isBuy3Get1PromoType(typeValue) {
                    const normalized = String(typeValue || '').trim().toLowerCase();
                    return normalized === 'buy 3 get 4' || normalized === 'buy 3 get 1';
                },
                lineHasBuy3Get1Promo(line) {
                    const edges = line?.node?.merchandise?.product?.collections?.edges || [];
                    return edges.findIndex(edge => this.isBuy3Get1PromoType(edge?.node?.type?.value || edge?.node?.type)) > -1;
                },
                async newCart(merchandise, qty, vehicles, location, promo, isTyre) {
                    let queryJSON = {
                        "query": `mutation cartCreate($input: CartInput) {
                          cartCreate(input: $input) {
                            ${this.cartString}`,
                        "operationName": "cartCreate",
                        "variables": {
                            "input": {}
                        }
                    }
                    queryJSON.variables.input.buyerIdentity = {
                        countryCode: 'AU',
                        preferences: {
                            delivery: {
                                deliveryMethod: 'PICK_UP'
                            }
                        }
                    }
                    if (location?.latitude && location?.longitude) {
                        queryJSON.variables.input.buyerIdentity.preferences.delivery.coordinates = {
                            latitude: location.latitude,
                            longitude: location.longitude,
                            countryCode: 'AU'
                        }
                    }
                    const storeSelector = window.storeSelector();
                    if (storeSelector.nearestStore || localStorage.getItem('currentNearestStore')) {
                        queryJSON.variables.input.attributes = []
                        queryJSON.variables.input.attributes.push({
                            "key": "location",
                            "value": storeSelector.nearestStore.node.id || JSON.parse(localStorage.getItem('currentNearestStore')).node.id || ""
                        })
                        queryJSON.variables.input.buyerIdentity.preferences.delivery.pickupHandle = storeSelector.nearestStore.node.id || JSON.parse(localStorage.getItem('currentNearestStore')).node.id
                    }
                    if (vehicles[0]?.rego && vehicles[0]?.regoState) {
                        queryJSON.variables.input.attributes.push({
                            "key": "rego",
                            "value": `${vehicles[0].rego} ${vehicles[0].regoState}`
                        })
                    }
                    if (vehicles[0]?.name) {
                        queryJSON.variables.input.attributes.push({
                            "key": "makeModel",
                            "value": vehicles[0].name
                        })
                    }

                    queryJSON.variables.input.lines = [
                        {
                            quantity: qty,
                            merchandiseId: `gid://shopify/ProductVariant/${merchandise}`
                        }
                    ]
                    if (promo && Math.floor(qty / 4) > 0) {
                        queryJSON.variables.input.lines.push({
                            quantity: Math.floor(qty / 4),
                            merchandiseId: `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`
                        })
                    }
                    let queryString = JSON.stringify(queryJSON);
                    let options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: queryString
                    };
                    let createNewCart = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => response.json())
                            .then(object => {
                                resolve(object)
                            })
                            .catch(err => {
                                console.log(`Error submitting to cart: ${err}`)
                            })
                    })
                    let response = await createNewCart
                    if (response?.data?.cartCreate?.userErrors?.length > 0) {
                        for (let i = 0; i < response.data.cartCreate.userErrors.length; i++) {
                            if (response.data.cartCreate.userErrors[i]?.message?.toLowerCase().includes('fitting fee')) {
                                let newResponse
                                for (let z = 0; ; z++) {
                                    let fitIndex = queryJSON.variables.input.lines.findIndex(line => line.merchandiseId == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`)
                                    if (fitIndex > -1) {
                                        queryJSON.variables.input.lines.splice(fitIndex, 1);
                                    }
                                    queryJSON.variables.input.lines.push({
                                        quantity: z + 1,
                                        merchandiseId: `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`
                                    })
                                    options.body = JSON.stringify(queryJSON);
                                    createNewCart = new Promise(function (resolve, reject) {
                                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                                            .then(response => response.json())
                                            .then(object => {
                                                resolve(object)
                                            })
                                            .catch(err => {
                                                console.log(`Error submitting to cart: ${err}`)
                                            })
                                    })
                                    newResponse = await createNewCart;
                                    if (newResponse?.data?.cartCreate?.userErrors?.length == 0) {
                                        response = newResponse;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    let cartInfo = await response.data.cartCreate.cart
                    this.cartData = {
                        id: await cartInfo.id,
                        url: await cartInfo.checkoutUrl
                    }
                    localStorage.setItem('cartData', JSON.stringify(await this.cartData));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            cartData: {
                                siteData: await this.cartData,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    let updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['cartData'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    for (let i = 0; i < cartInfo.lines.edges.length; i++) {
                        cartInfo.lines.edges[i].node.totalPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.subtotalAmount?.amount || 0))
                        cartInfo.lines.edges[i].node.discountPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.totalAmount?.amount || 0))
                    }
                    this.cartContent = this.discountMangement(cartInfo)
                    this.showCart = true
                    this.justAdded = true
                    this.justAddedIsTyre = !!isTyre
                    return createNewCart;
                },
                async cartAdd(merchandise, qty, id, promo, isTyre) {
                    if (this?.cartContent?.lines?.edges?.length > 0) {
                        let waIdx = this.cartContent.lines.edges.findIndex(edge => edge.node.merchandise.product.handle.includes("wheel-alignment"))
                        if (waIdx > -1) {
                            if (this.cartContent.lines.edges[waIdx].node.merchandise.id == `gid://shopify/ProductVariant/${merchandise}`) {
                                return 'cartFull';
                            }
                        }
                    }
                    let queryJSON = {
                        "query": `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
                          cartLinesAdd(cartId: $cartId, lines: $lines) {
                            ${this.cartString}`,
                        "operationName": "cartLinesAdd",
                        "variables": {
                            "cartId": id,
                            "lines": [
                                {
                                    "quantity": qty,
                                    "merchandiseId": `gid://shopify/ProductVariant/${merchandise}`
                                }
                            ]
                        }
                    }
                    let fittingAddition = false;
                    let promoTotal = 0;
                    if (promo) {
                        let fittingQty = 0;
                        promoTotal = qty;
                        for (let i = 0; i < this?.cartContent?.lines?.edges?.length; i++) {
                            if (this.lineHasBuy3Get1Promo(this?.cartContent?.lines?.edges[i]) && this?.cartContent?.lines?.edges[i]?.node?.merchandise?.product?.collections?.edges?.findIndex(e => e.node.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                                promoTotal = promoTotal + this.cartContent.lines.edges[i].node.quantity || 0;
                            }
                            if (fittingQty == 0 && this?.cartContent?.lines?.edges[i]?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`) {
                                fittingQty = fittingQty + this.cartContent.lines.edges[i].node.quantity || 0;
                            }
                        }
                        if (fittingQty == 0 && Math.floor(promoTotal / 4) > 0) {
                            queryJSON.variables.lines.push({
                                quantity: Math.floor(promoTotal / 4),
                                merchandiseId: `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`
                            })
                        } else if (fittingQty > 0 && Math.floor(promoTotal / 4) != fittingQty) {
                            fittingAddition = true;
                        }
                        if (fittingAddition) {
                            let fitidx = this.cartContent.lines.edges.findIndex(edge => edge?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`)
                            if (fitidx > -1) {
                                this.cartContent.lines.edges[fitidx].node.quantity = Math.floor(promoTotal / 4);
                                let responseDetails = await this.cartUpdate(fitidx);
                            }
                        }
                    }
                    let queryString = JSON.stringify(queryJSON);
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: queryString
                    };
                    const addToCart = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => response.json())
                            .then(object => {
                                resolve(object)
                            })
                            .catch(err => {
                                console.log(`Error submitting to cart: ${err}`)
                            })
                    })
                    let response = await addToCart
                    let cartInfo = await response.data.cartLinesAdd.cart
                    for (let i = 0; i < cartInfo.lines.edges.length; i++) {
                        cartInfo.lines.edges[i].node.totalPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.subtotalAmount?.amount || 0))
                        cartInfo.lines.edges[i].node.discountPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.totalAmount?.amount || 0))
                    }
                    this.cartContent = this.discountMangement(cartInfo)
                    this.showCart = true
                    this.justAdded = true
                    this.justAddedIsTyre = !!isTyre
                },
                //Pass lines as array
                async cartRemove(cartID, lineIDarray) {
                    let queryJSON = {
                        "query": `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
                          cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
                            ${this.cartString}`,
                        "operationName": "cartLinesRemove",
                        "variables": {
                            "cartId": cartID,
                            "lineIds": lineIDarray
                        }
                    }
                    let fittingReduction = false;
                    let promoTotal = 0;
                    let promoLines = this?.cartContent?.lines?.edges?.filter(edge => lineIDarray.includes(edge?.node?.id) && this.lineHasBuy3Get1Promo(edge) && edge?.node?.merchandise?.product?.collections?.edges?.findIndex(e => e.node.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) || [];
                    let fitidx = this?.cartContent?.lines?.edges.findIndex(edge => edge?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`);
                    let fittingQty = 0;
                    if (promoLines.length > 0 && fitidx > -1) {
                        for (let i = 0; i < this.cartContent.lines.edges.length; i++) {
                            if (!lineIDarray.includes(this.cartContent.lines.edges[i]?.node?.id) && this.lineHasBuy3Get1Promo(this?.cartContent?.lines?.edges[i])) {
                                promoTotal = promoTotal + this.cartContent.lines.edges[i].node.quantity || 0;
                            }
                            if (fittingQty == 0 && this?.cartContent?.lines?.edges[i]?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`) {
                                fittingQty = fittingQty + this.cartContent.lines.edges[i].node.quantity || 0;
                            }
                        }
                        if (fittingQty > 0 && Math.floor(promoTotal / 4) == 0) {
                            queryJSON.variables.lineIds.push(this.cartContent.lines.edges[fitidx].node.id)
                        } else if (fittingQty > 0 && fittingQty != Math.floor(promoTotal / 4)) {
                            fittingReduction = true;
                        }
                    }

                    let queryString = JSON.stringify(queryJSON);
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: queryString
                    };
                    const removeFromCart = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => response.json())
                            .then(object => {
                                resolve(object)
                            })
                            .catch(err => {
                                console.log(`Error submitting to cart: ${err}`)
                            })
                    })
                    let response = await removeFromCart
                    let cartInfo = await response.data.cartLinesRemove.cart
                    for (let i = 0; i < cartInfo.lines.edges.length; i++) {
                        cartInfo.lines.edges[i].node.totalPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.subtotalAmount?.amount || 0))
                        cartInfo.lines.edges[i].node.discountPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.totalAmount?.amount || 0))
                    }
                    this.cartContent = this.discountMangement(cartInfo)
                    this.showCart = true
                    if (fittingReduction) {
                        let fitidxFresh = this.cartContent.lines.edges.findIndex(edge => edge?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`)
                        if (fitidxFresh > -1) {
                            this.cartContent.lines.edges[fitidxFresh].node.quantity = Math.floor(promoTotal / 4);
                            return this.cartUpdate(fitidxFresh)
                        }
                    } else {
                        return removeFromCart;
                    }
                },
                async cartUpdate(index) {
                    if (this?.cartContent?.lines?.edges[index]?.node?.merchandise?.product?.handle?.includes("wheel-alignment") && this?.cartContent?.lines?.edges[index]?.node?.quantity > 1) {
                        this.cartContent.lines.edges[index].node.quantity = 1;
                        console.error("Error: cannot add more than one wheel alignment to cart");
                    }
                    let queryJSON = {
                        "query": `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
                            cartLinesUpdate(cartId: $cartId, lines: $lines) {
                            ${this.cartString}`,
                        "operationName": "cartLinesUpdate",
                        "variables": {
                            "cartId": this.cartData.id,
                            "lines": [
                                {
                                    "id": this.cartContent.lines.edges[index].node.id,
                                    "quantity": this.cartContent.lines.edges[index].node.quantity
                                }
                            ]
                        }
                    }
                    let fittingAddition = false;
                    let fittingRemoval = false;
                    let promoTotal = 0;
                    let fitidx = this?.cartContent?.lines?.edges.findIndex(edge => edge?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`);
                    let fittingQty = 0;
                    for (let i = 0; i < this.cartContent.lines.edges.length; i++) {
                        if (this.lineHasBuy3Get1Promo(this?.cartContent?.lines?.edges[i]) && this?.cartContent?.lines?.edges[i]?.node?.merchandise?.product?.collections?.edges?.findIndex(e => e.node.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                            promoTotal = promoTotal + this.cartContent.lines.edges[i].node.quantity || 0;
                        }
                        if (fittingQty == 0 && this?.cartContent?.lines?.edges[i]?.node?.merchandise?.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`) {
                            fittingQty = fittingQty + this.cartContent.lines.edges[i].node.quantity || 0;
                        }
                    }
                    if (fitidx > -1 && fittingQty != Math.floor(promoTotal / 4) && Math.floor(promoTotal / 4) > 0) {
                        queryJSON.variables.lines.push({
                            id: this.cartContent.lines.edges[fitidx].node.id,
                            quantity: Math.floor(promoTotal / 4)
                        })
                    } else if (fitidx > -1 && fittingQty != Math.floor(promoTotal / 4) && Math.floor(promoTotal / 4) == 0) {
                        fittingRemoval = true;
                    } else if (fitidx == -1 && Math.floor(promoTotal / 4) > 0) {
                        fittingAddition = true
                    }
                    let responseDetails
                    if (fittingAddition) {
                        responseDetails = await this.cartAdd(shopifyConfig.fitmentFeeProd, Math.floor(promoTotal / 4), this.cartData.id, false)
                    } else if (fittingRemoval) {
                        responseDetails = await this.cartRemove(this.cartData.id, [this.cartContent.lines.edges[fitidx].node.id])
                    }
                    let queryString = JSON.stringify(queryJSON);
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: queryString
                    };
                    const cartUpdate = new Promise(function (resolve) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => response.json())
                            .then(object => {
                                resolve(object)
                            })
                            .catch(err => {
                                console.log(`Error submitting to cart: ${err}`)
                            })
                    })
                    let response = await cartUpdate
                    let cartInfo = await response.data.cartLinesUpdate.cart;
                    for (let i = 0; i < cartInfo.lines.edges.length; i++) {
                        cartInfo.lines.edges[i].node.totalPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.subtotalAmount?.amount || 0))
                        cartInfo.lines.edges[i].node.discountPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.totalAmount?.amount || 0))
                    }
                    this.cartContent = this.discountMangement(cartInfo)
                    this.showCart = true
                    this.pending = false
                },
                async buyGetCheckUpdate(cartLines, cartID) {
                    if (!Array.isArray(cartLines)) {
                        return 'passed'
                    }
                    let buyGetTags = 0;
                    let taggedLines = cartLines.filter(line => this.lineHasBuy3Get1Promo(line) && line?.node?.merchandise?.product?.collections?.edges?.findIndex(e => e.node.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1)
                    for (let i = 0; i < taggedLines.length; i++) {
                        buyGetTags = buyGetTags + taggedLines[i].node.quantity;
                    }
                    let fittingQuantity = Math.floor(buyGetTags / 4);
                    let fittingCartTotal = 0;
                    let fittingLines = cartLines.filter(line => line.node.merchandise.id == `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd}`)
                    for (let i = 0; i < fittingLines.length; i++) {
                        fittingCartTotal = fittingCartTotal + fittingLines[i].node.quantity;
                    }
                    const bgu = new Promise(async (resolve) => {
                        let response
                        if (fittingCartTotal == 0) {
                            if (fittingCartTotal < fittingQuantity) {
                                try {
                                    response = await this.cartAdd(shopifyConfig.fitmentFeeProd, fittingQuantity, cartID, true)
                                    response = await response.data.cartLinesAdd.cart
                                } catch (error) {
                                    console.log(`Error adding to cart: ${error}`)
                                    resolve('failed')
                                }
                                if (response) {
                                    resolve(response)
                                }
                            }
                        }
                        if (fittingQuantity == 0) {
                            if (fittingCartTotal > fittingQuantity) {
                                let fittingArray = []
                                for (let i = 0; i < fittingLines.length; i++) {
                                    fittingArray.push(fittingLines[i].node.id)
                                }
                                try {
                                    response = await this.cartRemove(cartID, fittingArray)
                                    response = await response.data.cartLinesRemove.cart
                                } catch (error) {
                                    console.log(`Error removing from cart: ${error}`)
                                    resolve('failed')
                                }
                                if (response) {
                                    resolve(response)
                                }
                            }
                        }
                        if (fittingCartTotal != fittingQuantity) {
                            if (fittingLines.length == 1) {
                                let fitIndex = this?.cartContent?.lines?.edges.findIndex(edge => edge?.node?.id == fittingLines[0]?.node?.id)
                                if (fitIndex > -1) {
                                    this.cartContent.lines.edges[fitIndex].node.quantity = fittingQuantity
                                    try {
                                        let response = await this.cartUpdate(fitIndex)
                                        response = await response.data.cartLinesUpdate.cart
                                    } catch (error) {
                                        console.log(`Error updating cart: ${error}`)
                                        resolve('failed')
                                    }
                                    if (response) {
                                        resolve(response)
                                    }
                                } else {
                                    resolve('error');
                                }
                            } else if (fittingLines.length > 1) {
                                let fittingArray = []
                                for (let i = 0; i < fittingLines.length; i++) {
                                    if (i == 0) {
                                        let fitIndex = this.cartContent.lines.edges.findIndex(edge => edge.node.id == fittingLines[i].node.id)
                                        if (fitIndex > -1) {
                                            this.cartContent.lines.edges[fitIndex].node.quantity = fittingQuantity
                                            try {
                                                response = await this.cartUpdate(fitIndex)
                                                response = await response.data.cartLinesUpdate.cart
                                            } catch (error) {
                                                console.log(`Error updating cart: ${error}`)
                                                resolve('failed')
                                            }
                                        } else {
                                            resolve('error')
                                        }
                                    } else {
                                        fittingArray.push(fittingLines[i].node.id)
                                    }
                                }
                                if (fittingArray.length > 0) {
                                    try {
                                        response = await this.cartRemove(cartID, fittingArray)
                                        response = await response.data.cartLinesRemove.cart
                                    } catch (error) {
                                        console.log(`Error removing from cart: ${error}`)
                                        resolve('failed')
                                    }
                                    if (response) {
                                        resolve(response)
                                    }
                                } else {
                                    resolve(response)
                                }
                            }
                        }
                        resolve(response || 'passed')
                    })
                    return bgu
                },
                async cartLoad() {
                    if (localStorage.getItem('checkoutDetails')) {
                        let loadDetails = JSON.parse(localStorage.getItem('checkoutDetails'))
                        this.vehicleLPN = loadDetails.vehicleLPN
                        this.vehicleState = loadDetails.vehicleState
                        this.vehicleMakeModel = loadDetails.vehicleMakeModel
                        this.storeNotes = loadDetails.storeNotes
                        this.fitmentDate = loadDetails.fitmentDate
                        this.fitmentTime = loadDetails.fitmentTime
                        this.confirmTyreWheelSize = !!loadDetails.confirmTyreWheelSize
                        this.confirmStockTerms = !!loadDetails.confirmStockTerms
                    }
                    if (localStorage.getItem('cartData')) {
                        this.cartData = JSON.parse(localStorage.getItem('cartData'))
                        let queryString = `{
	                        cart(id:"${this.cartData.id}") {
		                        id
			                    checkoutUrl
            			        totalQuantity
                                attribute(key:"logrocket") {
                                    value
                                }
                                attributes {
                                    key
                                    value
                                }
			                    cost {
				                    totalAmount {
            					        amount
			            	        }
				                    subtotalAmount {
            					        amount
			            	        }
			                    }
            			        lines(first:50) {
			            	        edges {
					                    node {
            						        id
			            			        merchandise {
						            	        ... on ProductVariant {
                                                    id
            								        sku
			            					        image {
						            			        altText
									                    url
            								        }
			            					        product {
                                                        id
									                    title
            									        handle
                                                        collections(first:50) {
                                                            edges {
                                                                node {
                                                                    id
                                                                    title: metafield(namespace:"promotion",key:"title") {
            										                    value
			            						                    }
                                                                    type: metafield(namespace:"promotion",key:"type") {
									            	                    value
            									                    }
                                                                }
                                                            }
                                                        }
                                                        metafield(namespace:"wts",key:"sf") {
                                                            value
                                                        }
                                                        category {
                                                            name
                                                        }
            								        }
			            					        price {
						            			        amount
								                    }
							                    }
            						        }
			            			        quantity
						                    discountAllocations {
							                    discountedAmount {
            								        amount
			            				        }
						                    }
                                            cost {
                                                subtotalAmount {
                                                    amount
                                                }
                                                totalAmount {
                                                    amount
                                                }
                                            }
            					        }
			            	        }
            			        }
                            }
                        }`
                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                            },
                            body: JSON.stringify({ query: queryString })
                        };
                        const cartVerify = new Promise(function (resolve, reject) {
                            fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                                .then(response => response.json())
                                .then(object => {
                                    if (object.data.cart) {
                                        resolve(object)
                                    } else {
                                        localStorage.removeItem('cartData')
                                        this.cartContent = false
                                    }
                                })
                                .catch(err => {
                                    console.log(`Error verifying cart: ${err}`)
                                })
                        })
                        let response = await cartVerify
                        let cartInfo = await response.data.cart
                        if (shopifyConfig.fitmentFeeProd && shopifyConfig.fitmentFeeProd != "") {
                            let buyCheck = await this.buyGetCheckUpdate(cartInfo.lines.edges, this.cartData.id)
                            if (typeof buyCheck == 'object') {
                                cartInfo = buyCheck
                            }
                        }
                        for (let i = 0; i < cartInfo.lines.edges.length; i++) {
                            cartInfo.lines.edges[i].node.totalPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.subtotalAmount?.amount || 0))
                            cartInfo.lines.edges[i].node.discountPrice = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(cartInfo.lines.edges[i]?.node?.cost?.totalAmount?.amount || 0))
                        }
                        this.cartContent = this.discountMangement(cartInfo)
                        const vehicleSearch = window.vehicleSearch();
                        const activeVehicleId = vehicleSearch.activeVehicleId || localStorage.getItem('activeVehicleId');
                        if (activeVehicleId) {
                            const liveVehicle = vehicleSearch.vehicles.find(v => String(v?.id) === String(activeVehicleId));
                            if (liveVehicle) {
                                this.vehicleMakeModel = `${liveVehicle.make.display_name} ${liveVehicle.model.display_name} ${liveVehicle.display_name}`;
                            } else {
                                try {
                                    const localVehicles = JSON.parse(localStorage.getItem('vehicles') || '[]');
                                    const localVehicle = localVehicles.find(v => String(v?.id) === String(activeVehicleId));
                                    if (localVehicle) {
                                        this.vehicleMakeModel = `${localVehicle.make.display_name} ${localVehicle.model.display_name} ${localVehicle.display_name}`;
                                    }
                                } catch (e) { }
                            }
                        }
                        let params = new URLSearchParams(window.location.search)
                        if (params?.get('cart') == "email") {
                            this.showCart = true;
                            history.replaceState(null, '', window.location.href.replaceAll(window.location.search, ''));
                        }
                        return cartVerify;
                    } else {

                        return false
                    }
                },
                hideCart() {
                    this.showCart = false
                    this.openCheckout = false
                },
                qtyChange(val, index) {
                    this.cartContent.lines.edges[index].node.quantity = this.cartContent.lines.edges[index].node.quantity + val;
                    if (!this.pending) {
                        this.pending = true
                        setTimeout(this.cartUpdate, 1000, index)
                    }
                },
                showCheckout() {
                    this.openCheckout = true
                },
                hideCheckout() {
                    this.openCheckout = false
                },
                async validateCheckout() {
                    if (((this.vehicleLPN && this.vehicleLPN != '' && this.vehicleState && this.vehicleState != '') || this.unknownRego) && this.vehicleMakeModel && this.vehicleMakeModel != '' && this.fitmentDate && this.fitmentDate.includes('-') && this.fitmentTime && this.fitmentTime.includes(':') && this.confirmTyreWheelSize && this.confirmStockTerms) {
                        if (shopifyConfig.fitmentFeeProd && shopifyConfig.fitmentFeeProd != "") {
                            const cartLines = this?.cartContent?.lines?.edges || []
                            const cartId = this?.cartData?.id || ''
                            if (!cartId) {
                                this.enableProceedToPayment = false;
                                return;
                            }
                            let resp = await this.buyGetCheckUpdate(cartLines, cartId)
                            if (resp != 'failed') {
                                this.enableProceedToPayment = true;
                            } else {
                                this.enableProceedToPayment = false;
                            }
                        } else {
                            this.enableProceedToPayment = true;
                        }
                    } else {
                        this.enableProceedToPayment = false;
                    }
                },
                async submitCheckout() {
                    if (this.isProceedingToPayment) {
                        return
                    }
                    this.isProceedingToPayment = true;

                    const retrieveCart = async (id) => {
                        try {
                            const queryString = `{
	                            cart(id:"${id}") {
	    	                        id
        		                    checkoutUrl
	    	                        discountCodes {
		    	                        applicable
		                                code
	                                }
	                                lines(first:50) {
		    	                        edges {
	    			                        node {
    					                        merchandise {
						                            ... on ProductVariant {
						                                id
					                                }
    				                            }
	    			                            quantity
		    	                            }
		                                }
		                            }
                                }
                            }`
                            const options = {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                                },
                                body: JSON.stringify({ query: queryString })
                            };
                            const cartResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options);
                            const cartResponseJSON = await cartResponse.json();
                            if (cartResponseJSON?.data?.cart) return cartResponseJSON.data.cart;
                            throw new Error(`Failed to retrieve cart`);
                        } catch (e) {
                            console.error(`Error fetching cart ${e}`);
                        }
                    };

                    const generateCart = async (store, rego, makeModel, fitmentDateTime, storeNotes, lines, discountCodes) => {
                        try {
                            const queryJSON = {
                                "query": `mutation cartCreate($input: CartInput) {
                                    cartCreate(input: $input) {
                                        cart {
			                                id
    			                            checkoutUrl
                                            attributes {
                                                key
                                                value
                                            }
                                        }
                                        userErrors {
                                            field
                                            message
                                        }
                                        warnings {
                                            code
			                                message
			                                target
                                        }
                                    }
                                }`,
                                "operationName": "cartCreate",
                                "variables": {
                                    input: {
                                        lines: [],
                                        discountCodes: [],
                                        attributes: [
                                            {
                                                "key": "location",
                                                "value": store.id
                                            },
                                            {
                                                "key": "rego",
                                                "value": rego
                                            },
                                            {
                                                "key": "makeModel",
                                                "value": makeModel
                                            },
                                            {
                                                "key": "fitmentDateTime",
                                                "value": fitmentDateTime
                                            },
                                            {
                                                "key": "storeNotes",
                                                "value": storeNotes
                                            }
                                        ],
                                        buyerIdentity: {
                                            countryCode: 'AU',
                                            preferences: {
                                                delivery: {
                                                    deliveryMethod: 'PICK_UP',
                                                    pickupHandle: store.id,
                                                    coordinates: {
                                                        countryCode: 'AU',
                                                        latitude: store.address.latitude,
                                                        longitude: store.address.longitude
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (localStorage.getItem('lrs')) {
                                queryJSON.variables.input.attributes.push({
                                    key: "logrocket",
                                    value: localStorage.getItem('lrs')
                                })
                            } else if (typeof LogRocket != 'undefined') {
                                try {
                                    LogRocket.getSessionURL((url) => {
                                        queryJSON.variables.input.attributes.push({
                                            key: "logrocket",
                                            value: url
                                        })
                                    })
                                } catch (e) {
                                    console.error(e);
                                }
                            }
                            const vehicleSearch = window.vehicleSearch();
                            if (vehicleSearch?.vehicles?.[0]?.vehicle_id) {
                                queryJSON.variables.input.attributes.push({
                                    key: "vehicleId",
                                    value: `${vehicleSearch.vehicles[0].vehicle_id}`
                                })
                            }
                            lines?.edges?.forEach((edge) => {
                                if (edge?.node?.merchandise?.id && edge?.node?.quantity) {
                                    queryJSON.variables.input.lines.push({
                                        merchandiseId: edge.node.merchandise.id,
                                        quantity: edge.node.quantity
                                    })
                                }
                            })
                            discountCodes.forEach((discount) => {
                                if (discount?.applicable) {
                                    queryJSON.variables.input.discountCodes.push(discount.code)
                                }
                            })
                            const queryString = JSON.stringify(queryJSON);
                            const options = {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                                },
                                body: queryString
                            };
                            const cartResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options);
                            const cartResponseJSON = await cartResponse.json();
                            cartResponseJSON?.data?.cartCreate?.warnings?.forEach((warning) => {
                                console.error(`${warning.code}: ${warning.message}`);
                            })
                            if (cartResponseJSON?.data?.cartCreate?.userErrors?.length === 0 && cartResponseJSON?.data?.cartCreate.cart) {
                                return cartResponseJSON?.data?.cartCreate.cart;
                            }
                            throw new Error(cartResponseJSON.data.cartCreate.userErrors);
                        } catch (e) {
                            console.error(`Error generating cart`, e);
                        }
                    };

                    try {
                        const storeSelector = window.storeSelector ? window.storeSelector() : null;
                        const cachedStore = (() => {
                            try {
                                return JSON.parse(localStorage.getItem('currentNearestStore') || 'null');
                            } catch (e) {
                                return null;
                            }
                        })();
                        const storeNode = storeSelector?.nearestStore?.node || storeSelector?.node || cachedStore?.node || null;
                        if (!this.cartData?.id || !this.cartData?.url) {
                            try {
                                const cachedCart = JSON.parse(localStorage.getItem('cartData') || 'null');
                                if (cachedCart?.id) this.cartData = cachedCart;
                            } catch (e) { }
                        }
                        let dateArray = this.fitmentDate.split('-') || 'fail';
                        if (dateArray == 'fail') {
                            console.error('No Date selected');
                            this.isProceedingToPayment = false
                            return;
                        }

                        let newDate = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
                        if (newDate.includes('undefined')) {
                            console.error('No Date selected');
                            this.isProceedingToPayment = false
                            return;
                        }

                        const currentCart = await retrieveCart(this.cartData.id);
                        const newCart = await generateCart(storeNode, `${this.vehicleLPN} ${this.vehicleState}`, this.vehicleMakeModel, `${newDate} ${this.fitmentTime}`, this.storeNotes, currentCart.lines, currentCart.discountCodes)
                        if (newCart.attributes?.length >= 4 && newCart.id && newCart.checkoutUrl) {
                            this.confirmTyreWheelSize = false;
                            this.confirmStockTerms = false;
                            let details = localStorage.getItem('checkoutDetails')
                            if (details) {
                                try {
                                    details = JSON.parse(details);
                                    delete (details.confirmTyreWheelSize);
                                    delete (details.confirmStockTerms);
                                    localStorage.setItem('checkoutDetails', JSON.stringify(details))
                                } catch (err) {
                                    console.error(`Error, cart details object not found: ${err}`)
                                }
                            }
                            localStorage.setItem('cartData', JSON.stringify({
                                id: newCart.id,
                                url: newCart.checkoutUrl
                            }))
                            localStorage.setItem('cartToken', newCart.id.split('?')[0].replaceAll("gid://shopify/Cart/", ""));
                            localStorage.removeItem('lr_attribute_set')
                            window.location.href = newCart.checkoutUrl;
                        } else {
                            throw new Error(`Error generating cart`);
                        }
                    } catch (err) {
                        console.error(`Checkout submit failed: ${err}`)
                    } finally {
                        this.isProceedingToPayment = false
                    }
                }
            }
        })
    } else {
        setTimeout(waitForVueAndPinia, 100);
    }
})();

// Refresh on wake-up: reload if the date has changed since the tab was hidden (Melbourne time)
(function () {
    const localDate = (ms) => new Date(ms).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' });
    let hiddenAt = null;
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
            hiddenAt = Date.now();
        } else if (document.visibilityState === 'visible' && hiddenAt) {
            if (localDate(Date.now()) !== localDate(hiddenAt)) {
                window.location.reload();
            }
            hiddenAt = null;
        }
    });
})();

let dynamicSlideshow = {}
